import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import classNames from 'classnames';
import React, { useState, useLayoutEffect, useEffect, useRef, useContext, createContext } from 'react';
import { isBreakpointAtLeast, isBreakpointAtMost, Breakpoint, PanelPosition, getLinkAttributesFromDestinationType, SvgUtils as SvgUtils$1, CTATextIconSizeMap, spacingTokens, KIND, getContent, getTabIconDensity, getTabsToggleIconDensity, isTextInputDataValid, createTextClassNames, BigNumberUseCase, BigNumberTextSizeMap, TextSize, HeadingUseCase, HeadingTextSizeMap, TextKind, ParagraphUseCase, ParagraphTextSizeMap, TextUIUseCase, TextUISizeMap, TextEmphasis } from '@rig/common';
import { FocusScope } from '@react-aria/focus';
import axios from 'axios';
import { useId } from '@react-aria/utils';

function dispatchEvent$1(dispatcher, data) {
  if (dispatcher && dispatcher.next !== undefined) {
    dispatcher.next(data);
  } else if (dispatcher) {
    dispatcher(data);
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$k =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$g = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$f = fails$g;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$f(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$e = fails$g;

var functionBindNative = !fails$e(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$e = Function.prototype.call;

var functionCall = NATIVE_BIND$3 ? call$e.bind(call$e) : function () {
  return call$e.apply(call$e, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$4 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$d = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$2 && FunctionPrototype$2.bind.bind(call$d, call$d);

var functionUncurryThis = NATIVE_BIND$2 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$d.apply(fn, arguments);
  };
};

var uncurryThis$h = functionUncurryThis;

var toString$5 = uncurryThis$h({}.toString);
var stringSlice$1 = uncurryThis$h(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$1(toString$5(it), 8, -1);
};

var uncurryThis$g = functionUncurryThis;
var fails$d = fails$g;
var classof$7 = classofRaw$2;

var $Object$4 = Object;
var split = uncurryThis$g(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$d(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$7(it) == 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$4 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$3 = isNullOrUndefined$4;

var $TypeError$e = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$3 = function (it) {
  if (isNullOrUndefined$3(it)) throw $TypeError$e("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$2 = requireObjectCoercible$3;

var toIndexedObject$5 = function (it) {
  return IndexedObject$1(requireObjectCoercible$2(it));
};

var documentAll$2 = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;

var documentAll_1 = {
  all: documentAll$2,
  IS_HTMLDDA: IS_HTMLDDA
};

var $documentAll$1 = documentAll_1;

var documentAll$1 = $documentAll$1.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$l = $documentAll$1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$k = isCallable$l;
var $documentAll = documentAll_1;

var documentAll = $documentAll.all;

var isObject$9 = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable$k(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable$k(it);
};

var global$j = global$k;
var isCallable$j = isCallable$l;

var aFunction = function (argument) {
  return isCallable$j(argument) ? argument : undefined;
};

var getBuiltIn$8 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$j[namespace]) : global$j[namespace] && global$j[namespace][method];
};

var uncurryThis$f = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$f({}.isPrototypeOf);

var getBuiltIn$7 = getBuiltIn$8;

var engineUserAgent = getBuiltIn$7('navigator', 'userAgent') || '';

var global$i = global$k;
var userAgent$5 = engineUserAgent;

var process$3 = global$i.process;
var Deno$1 = global$i.Deno;
var versions = process$3 && process$3.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$5) {
  match = userAgent$5.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$5.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION$1 = engineV8Version;
var fails$c = fails$g;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$c(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$2 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$6 = getBuiltIn$8;
var isCallable$i = isCallable$l;
var isPrototypeOf$3 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$6('Symbol');
  return isCallable$i($Symbol) && isPrototypeOf$3($Symbol.prototype, $Object$3(it));
};

var $String$3 = String;

var tryToString$5 = function (argument) {
  try {
    return $String$3(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$h = isCallable$l;
var tryToString$4 = tryToString$5;

var $TypeError$d = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$8 = function (argument) {
  if (isCallable$h(argument)) return argument;
  throw $TypeError$d(tryToString$4(argument) + ' is not a function');
};

var aCallable$7 = aCallable$8;
var isNullOrUndefined$2 = isNullOrUndefined$4;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$3 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$2(func) ? undefined : aCallable$7(func);
};

var call$c = functionCall;
var isCallable$g = isCallable$l;
var isObject$8 = isObject$9;

var $TypeError$c = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$g(fn = input.toString) && !isObject$8(val = call$c(fn, input))) return val;
  if (isCallable$g(fn = input.valueOf) && !isObject$8(val = call$c(fn, input))) return val;
  if (pref !== 'string' && isCallable$g(fn = input.toString) && !isObject$8(val = call$c(fn, input))) return val;
  throw $TypeError$c("Can't convert object to primitive value");
};

var shared$3 = {exports: {}};

var global$h = global$k;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$6(global$h, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$h[key] = value;
  } return value;
};

var global$g = global$k;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$g[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.26.1',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible$1 = requireObjectCoercible$3;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$4 = function (argument) {
  return $Object$2(requireObjectCoercible$1(argument));
};

var uncurryThis$e = functionUncurryThis;
var toObject$3 = toObject$4;

var hasOwnProperty = uncurryThis$e({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$3(it), key);
};

var uncurryThis$d = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$4 = uncurryThis$d(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$4(++id + postfix, 36);
};

var global$f = global$k;
var shared$2 = shared$3.exports;
var hasOwn$a = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$1 = global$f.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$g = function (name) {
  if (!hasOwn$a(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL$1 || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL$1 && hasOwn$a(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var call$b = functionCall;
var isObject$7 = isObject$9;
var isSymbol$1 = isSymbol$2;
var getMethod$2 = getMethod$3;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$f = wellKnownSymbol$g;

var $TypeError$b = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$f('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$7(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$2(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$b(exoticToPrim, input, pref);
    if (!isObject$7(result) || isSymbol$1(result)) return result;
    throw $TypeError$b("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$3 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$e = global$k;
var isObject$6 = isObject$9;

var document$3 = global$e.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$6(document$3) && isObject$6(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$b = descriptors;
var fails$b = fails$g;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$b && !fails$b(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$a = descriptors;
var call$a = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$3 = createPropertyDescriptor$4;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$2 = toPropertyKey$3;
var hasOwn$9 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$a ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$2(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$9(O, P)) return createPropertyDescriptor$3(!call$a(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$9 = descriptors;
var fails$a = fails$g;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$9 && fails$a(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var isObject$5 = isObject$9;

var $String$2 = String;
var $TypeError$a = TypeError;

// `Assert: Type(argument) is Object`
var anObject$a = function (argument) {
  if (isObject$5(argument)) return argument;
  throw $TypeError$a($String$2(argument) + ' is not an object');
};

var DESCRIPTORS$8 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$9 = anObject$a;
var toPropertyKey$1 = toPropertyKey$3;

var $TypeError$9 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$8 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$9(O);
  P = toPropertyKey$1(P);
  anObject$9(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$9(O);
  P = toPropertyKey$1(P);
  anObject$9(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$9('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$7 = descriptors;
var definePropertyModule$5 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$4;

var createNonEnumerableProperty$4 = DESCRIPTORS$7 ? function (object, key, value) {
  return definePropertyModule$5.f(object, key, createPropertyDescriptor$2(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$6 = descriptors;
var hasOwn$8 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$6 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$8(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$6 || (DESCRIPTORS$6 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$c = functionUncurryThis;
var isCallable$f = isCallable$l;
var store$1 = sharedStore;

var functionToString = uncurryThis$c(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$f(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$3 = store$1.inspectSource;

var global$d = global$k;
var isCallable$e = isCallable$l;

var WeakMap$1 = global$d.WeakMap;

var weakMapBasicDetection = isCallable$e(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$c = global$k;
var isObject$4 = isObject$9;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$4;
var hasOwn$7 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$2 = global$c.TypeError;
var WeakMap = global$c.WeakMap;
var set$1, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$4(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$2('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set$1 = function (it, metadata) {
    if (store.has(it)) throw TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$7(it, STATE)) throw TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$3(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$7(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$7(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var fails$9 = fails$g;
var isCallable$d = isCallable$l;
var hasOwn$6 = hasOwnProperty_1;
var DESCRIPTORS$5 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$3;
var InternalStateModule$2 = internalState;

var enforceInternalState = InternalStateModule$2.enforce;
var getInternalState$1 = InternalStateModule$2.get;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS$5 && !fails$9(function () {
  return defineProperty$5(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$6(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$5) defineProperty$5(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$6(options, 'arity') && value.length !== options.arity) {
    defineProperty$5(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$6(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$5) defineProperty$5(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$6(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$d(this) && getInternalState$1(this).source || inspectSource$2(this);
}, 'toString');

var isCallable$c = isCallable$l;
var definePropertyModule$4 = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$5 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$c(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$4.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$1 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$1 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max$1 = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$2 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max$1(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$4 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex$1 = toAbsoluteIndex$2;
var lengthOfArrayLike$3 = lengthOfArrayLike$4;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$3(O);
    var index = toAbsoluteIndex$1(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var uncurryThis$b = functionUncurryThis;
var hasOwn$5 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$1 = uncurryThis$b([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$5(hiddenKeys$2, key) && hasOwn$5(O, key) && push$1(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$5(O, key = names[i++])) {
    ~indexOf(result, key) || push$1(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$5 = getBuiltIn$8;
var uncurryThis$a = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$8 = anObject$a;

var concat$1 = uncurryThis$a([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$5('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$8(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$4 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$3 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$3.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$4(target, key) && !(exceptions && hasOwn$4(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$8 = fails$g;
var isCallable$b = isCallable$l;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$b(detection) ? fails$8(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$b = global$k;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$4;
var defineBuiltIn$4 = defineBuiltIn$5;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$1 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$b;
  } else if (STATIC) {
    target = global$b[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$b[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$2(sourceProperty, 'sham', true);
    }
    defineBuiltIn$4(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$4 = descriptors;
var uncurryThis$9 = functionUncurryThis;
var call$9 = functionCall;
var fails$7 = fails$g;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$2 = toObject$4;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$4 = Object.defineProperty;
var concat = uncurryThis$9([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$7(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$4 && $assign({ b: 1 }, $assign(defineProperty$4({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$4(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys$1($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$2(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$4 || call$9(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$c = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$c({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

const _excluded$j = ["background", "outline", "children", "elevation", "className"];
const BoxContainer = _ref => {
  let {
      background,
      outline,
      children,
      elevation,
      className = ''
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$j);
  const classes = classNames('rbc-box-container', {
    'rbc-box-container-background-primary': background === 'primary' || background === undefined,
    'rbc-box-container-background-alternate': background === 'alternate',
    'rbc-box-container-background-highlight': background === 'highlight',
    'rbc-box-container-outline-border': outline === 'border',
    'rbc-box-container-outline-full-width-border': outline === 'full-width-border',
    'rbc-box-container-elevation-1': elevation === 'elevation-1'
  });
  return jsx("div", Object.assign({
    className: `${classes} ${className}`
  }, props, {
    children: children
  }));
};

const Divider = ({
  direction,
  thickness
}) => {
  const classes = classNames('rbc-divider', {
    'rbc-divider-horizontal': direction === undefined || direction === 'horizontal',
    'rbc-divider-vertical': direction === 'vertical',
    'rbc-divider-thickness-sm': thickness === undefined || thickness === 'sm',
    'rbc-divider-thickness-md': thickness === 'md',
    'rbc-divider-thickness-lg': thickness === 'lg',
    'rbc-divider-thickness-xl': thickness === 'xl'
  });
  return jsx("div", {
    className: classes
  });
};

var objectDefineProperties = {};

var DESCRIPTORS$3 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$2 = objectDefineProperty;
var anObject$7 = anObject$a;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$3 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$7(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$2.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$4 = getBuiltIn$8;

var html$2 = getBuiltIn$4('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var anObject$6 = anObject$a;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$6(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$e = wellKnownSymbol$g;
var create$1 = objectCreate;
var defineProperty$3 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$e('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
  defineProperty$3(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$1(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$6 = fails$g;

var correctPrototypeGetter = !fails$6(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$3 = hasOwnProperty_1;
var isCallable$a = isCallable$l;
var toObject$1 = toObject$4;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject$1(O);
  if (hasOwn$3(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$a(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$1 ? ObjectPrototype : null;
};

var fails$5 = fails$g;
var isCallable$9 = isCallable$l;
var isObject$3 = isObject$9;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$3 = defineBuiltIn$5;
var wellKnownSymbol$d = wellKnownSymbol$g;

var ITERATOR$5 = wellKnownSymbol$d('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$3(IteratorPrototype$2) || fails$5(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$5].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$9(IteratorPrototype$2[ITERATOR$5])) {
  defineBuiltIn$3(IteratorPrototype$2, ITERATOR$5, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$2 = objectDefineProperty.f;
var hasOwn$2 = hasOwnProperty_1;
var wellKnownSymbol$c = wellKnownSymbol$g;

var TO_STRING_TAG$3 = wellKnownSymbol$c('toStringTag');

var setToStringTag$3 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$2(target, TO_STRING_TAG$3)) {
    defineProperty$2(target, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor$1 = createPropertyDescriptor$4;
var setToStringTag$2 = setToStringTag$3;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor$1(+!ENUMERABLE_NEXT, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var isCallable$8 = isCallable$l;

var $String$1 = String;
var $TypeError$8 = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$8(argument)) return argument;
  throw $TypeError$8("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThis$8 = functionUncurryThis;
var anObject$5 = anObject$a;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis$8(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$5(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$b = _export;
var call$8 = functionCall;
var FunctionName = functionName;
var isCallable$7 = isCallable$l;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag$1 = setToStringTag$3;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$4;
var defineBuiltIn$2 = defineBuiltIn$5;
var wellKnownSymbol$b = wellKnownSymbol$g;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4 = wellKnownSymbol$b('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$1) {
          setPrototypeOf$1(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$7(CurrentIteratorPrototype[ITERATOR$4])) {
          defineBuiltIn$2(CurrentIteratorPrototype, ITERATOR$4, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$1(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$8(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$2(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$b({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$4] !== defaultIterator) {
    defineBuiltIn$2(IterablePrototype, ITERATOR$4, defaultIterator, { name: DEFAULT });
  }
  Iterators$3[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$1 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$1 = addToUnscopables$2;
var Iterators$2 = iterators;
var InternalStateModule$1 = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject = createIterResultObject$1;
var DESCRIPTORS$2 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$2 && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$a = global$k;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$4;
var wellKnownSymbol$a = wellKnownSymbol$g;

var ITERATOR$3 = wellKnownSymbol$a('iterator');
var TO_STRING_TAG$2 = wellKnownSymbol$a('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$3] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$3, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$3] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$2]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$2, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$a[COLLECTION_NAME] && global$a[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

// eslint-disable-next-line @typescript-eslint/ban-types
const debounce = (fn, delay) => {
  let timer;
  return () => {
    clearTimeout(timer);
    timer = setTimeout(fn, delay);
  };
};
const useBreakPointService = sizeToken => {
  const [breakpoint, setBreakPoint] = useState({
    isAtLeast: isBreakpointAtLeast(window.innerWidth, sizeToken),
    isAtMost: isBreakpointAtMost(window.innerWidth, sizeToken),
    isExtraSmall: sizeToken === Breakpoint.extraSmall,
    isSmall: sizeToken === Breakpoint.small,
    isMedium: sizeToken === Breakpoint.medium,
    isLarge: sizeToken === Breakpoint.large,
    isExtraLarge: sizeToken === Breakpoint.extraLarge
  });
  useLayoutEffect(() => {
    const debounceHandleResize = debounce(function updateBreakPoints() {
      setBreakPoint({
        isAtLeast: isBreakpointAtLeast(window.innerWidth, sizeToken),
        isAtMost: isBreakpointAtMost(window.innerWidth, sizeToken),
        isExtraSmall: sizeToken === Breakpoint.extraSmall,
        isSmall: sizeToken === Breakpoint.small,
        isMedium: sizeToken === Breakpoint.medium,
        isLarge: sizeToken === Breakpoint.large,
        isExtraLarge: sizeToken === Breakpoint.extraLarge
      });
    }, 500);
    window.addEventListener('resize', debounceHandleResize);
    return () => {
      window.removeEventListener('resize', debounceHandleResize);
    };
  }, []);
  return [breakpoint];
};

var tryToString$3 = tryToString$5;

var $TypeError$7 = TypeError;

var deletePropertyOrThrow$1 = function (O, P) {
  if (!delete O[P]) throw $TypeError$7('Cannot delete property ' + tryToString$3(P) + ' of ' + tryToString$3(O));
};

var wellKnownSymbol$9 = wellKnownSymbol$g;

var TO_STRING_TAG$1 = wellKnownSymbol$9('toStringTag');
var test$2 = {};

test$2[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test$2) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$6 = isCallable$l;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$8 = wellKnownSymbol$g;

var TO_STRING_TAG = wellKnownSymbol$8('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$6 = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) == 'Object' && isCallable$6(O.callee) ? 'Arguments' : result;
};

var classof$5 = classof$6;

var $String = String;

var toString$3 = function (argument) {
  if (classof$5(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var toPropertyKey = toPropertyKey$3;
var definePropertyModule$1 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$4;

var createProperty$1 = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule$1.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var toAbsoluteIndex = toAbsoluteIndex$2;
var lengthOfArrayLike$2 = lengthOfArrayLike$4;
var createProperty = createProperty$1;

var $Array = Array;
var max = Math.max;

var arraySliceSimple = function (O, start, end) {
  var length = lengthOfArrayLike$2(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};

var arraySlice$2 = arraySliceSimple;

var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice$2(array, 0, middle), comparefn),
    mergeSort(arraySlice$2(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

var arraySort = mergeSort;

var fails$4 = fails$g;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$4(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var userAgent$4 = engineUserAgent;

var firefox = userAgent$4.match(/firefox\/(\d+)/i);

var engineFfVersion = !!firefox && +firefox[1];

var UA = engineUserAgent;

var engineIsIeOrEdge = /MSIE|Trident/.test(UA);

var userAgent$3 = engineUserAgent;

var webkit = userAgent$3.match(/AppleWebKit\/(\d+)\./);

var engineWebkitVersion = !!webkit && +webkit[1];

var $$a = _export;
var uncurryThis$7 = functionUncurryThis;
var aCallable$6 = aCallable$8;
var toObject = toObject$4;
var lengthOfArrayLike$1 = lengthOfArrayLike$4;
var deletePropertyOrThrow = deletePropertyOrThrow$1;
var toString$2 = toString$3;
var fails$3 = fails$g;
var internalSort = arraySort;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var FF = engineFfVersion;
var IE_OR_EDGE = engineIsIeOrEdge;
var V8 = engineV8Version;
var WEBKIT = engineWebkitVersion;

var test$1 = [];
var nativeSort = uncurryThis$7(test$1.sort);
var push = uncurryThis$7(test$1.push);

// IE8-
var FAILS_ON_UNDEFINED = fails$3(function () {
  test$1.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails$3(function () {
  test$1.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails$3(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test$1.push({ k: chr + index, v: value });
    }
  }

  test$1.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test$1.length; index++) {
    chr = test$1[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString$2(x) > toString$2(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$$a({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable$6(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike$1(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = lengthOfArrayLike$1(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});

var classof$4 = classofRaw$2;
var global$9 = global$k;

var engineIsNode = classof$4(global$9.process) == 'process';

var getBuiltIn$3 = getBuiltIn$8;
var definePropertyModule = objectDefineProperty;
var wellKnownSymbol$7 = wellKnownSymbol$g;
var DESCRIPTORS$1 = descriptors;

var SPECIES$2 = wellKnownSymbol$7('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$3(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS$1 && Constructor && !Constructor[SPECIES$2]) {
    defineProperty(Constructor, SPECIES$2, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var isPrototypeOf$2 = objectIsPrototypeOf;

var $TypeError$6 = TypeError;

var anInstance$1 = function (it, Prototype) {
  if (isPrototypeOf$2(Prototype, it)) return it;
  throw $TypeError$6('Incorrect invocation');
};

var uncurryThis$6 = functionUncurryThis;
var fails$2 = fails$g;
var isCallable$5 = isCallable$l;
var classof$3 = classof$6;
var getBuiltIn$2 = getBuiltIn$8;
var inspectSource$1 = inspectSource$3;

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn$2('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis$6(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$5(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$5(argument)) return false;
  switch (classof$3(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$2(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isConstructor = isConstructor$1;
var tryToString$2 = tryToString$5;

var $TypeError$5 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError$5(tryToString$2(argument) + ' is not a constructor');
};

var anObject$4 = anObject$a;
var aConstructor = aConstructor$1;
var isNullOrUndefined$1 = isNullOrUndefined$4;
var wellKnownSymbol$6 = wellKnownSymbol$g;

var SPECIES$1 = wellKnownSymbol$6('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$4(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined$1(S = anObject$4(C)[SPECIES$1]) ? defaultConstructor : aConstructor(S);
};

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$1 = FunctionPrototype.apply;
var call$7 = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$1 ? call$7.bind(apply$1) : function () {
  return call$7.apply(apply$1, arguments);
});

var classofRaw = classofRaw$2;
var uncurryThis$5 = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$5(fn);
};

var uncurryThis$4 = functionUncurryThisClause;
var aCallable$5 = aCallable$8;
var NATIVE_BIND = functionBindNative;

var bind$4 = uncurryThis$4(uncurryThis$4.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$5(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$4(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var uncurryThis$3 = functionUncurryThis;

var arraySlice$1 = uncurryThis$3([].slice);

var $TypeError$4 = TypeError;

var validateArgumentsLength$1 = function (passed, required) {
  if (passed < required) throw $TypeError$4('Not enough arguments');
  return passed;
};

var userAgent$2 = engineUserAgent;

var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);

var global$8 = global$k;
var apply = functionApply;
var bind$3 = functionBindContext;
var isCallable$4 = isCallable$l;
var hasOwn$1 = hasOwnProperty_1;
var fails$1 = fails$g;
var html = html$2;
var arraySlice = arraySlice$1;
var createElement = documentCreateElement$2;
var validateArgumentsLength = validateArgumentsLength$1;
var IS_IOS$1 = engineIsIos;
var IS_NODE$3 = engineIsNode;

var set = global$8.setImmediate;
var clear = global$8.clearImmediate;
var process$2 = global$8.process;
var Dispatch = global$8.Dispatch;
var Function$1 = global$8.Function;
var MessageChannel = global$8.MessageChannel;
var String$1 = global$8.String;
var counter = 0;
var queue$1 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global$8.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn$1(queue$1, id)) {
    var fn = queue$1[id];
    delete queue$1[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global$8.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable$4(handler) ? handler : Function$1(handler);
    var args = arraySlice(arguments, 1);
    queue$1[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$1[id];
  };
  // Node.js 0.8-
  if (IS_NODE$3) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind$3(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$8.addEventListener &&
    isCallable$4(global$8.postMessage) &&
    !global$8.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails$1(post)
  ) {
    defer = post;
    global$8.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var userAgent$1 = engineUserAgent;
var global$7 = global$k;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && global$7.Pebble !== undefined;

var userAgent = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

var global$6 = global$k;
var bind$2 = functionBindContext;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$2 = engineIsNode;

var MutationObserver = global$6.MutationObserver || global$6.WebKitMutationObserver;
var document$2 = global$6.document;
var process$1 = global$6.process;
var Promise$1 = global$6.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global$6, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$1.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify$1();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$2(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$2) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind$2(macrotask, global$6);
    notify$1 = function () {
      macrotask(flush);
    };
  }
}

var microtask$1 = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify$1();
  } last = task;
};

var global$5 = global$k;

var hostReportErrors$1 = function (a, b) {
  var console = global$5.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$3 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var Queue$1 = function () {
  this.head = null;
  this.tail = null;
};

Queue$1.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    if (this.head) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};

var queue = Queue$1;

var global$4 = global$k;

var promiseNativeConstructor = global$4.Promise;

/* global Deno -- Deno case */

var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

var IS_DENO$1 = engineIsDeno;
var IS_NODE$1 = engineIsNode;

var engineIsBrowser = !IS_DENO$1 && !IS_NODE$1
  && typeof window == 'object'
  && typeof document == 'object';

var global$3 = global$k;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var isCallable$3 = isCallable$l;
var isForced = isForced_1;
var inspectSource = inspectSource$3;
var wellKnownSymbol$5 = wellKnownSymbol$g;
var IS_BROWSER = engineIsBrowser;
var IS_DENO = engineIsDeno;
var V8_VERSION = engineV8Version;

NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var SPECIES = wellKnownSymbol$5('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$3(global$3.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR$5 = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$3);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$3);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor$3(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};

var newPromiseCapability$2 = {};

var aCallable$4 = aCallable$8;

var $TypeError$3 = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError$3('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$4(resolve);
  this.reject = aCallable$4(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var $$9 = _export;
var IS_NODE = engineIsNode;
var global$2 = global$k;
var call$6 = functionCall;
var defineBuiltIn$1 = defineBuiltIn$5;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$3;
var setSpecies = setSpecies$1;
var aCallable$3 = aCallable$8;
var isCallable$2 = isCallable$l;
var isObject$2 = isObject$9;
var anInstance = anInstance$1;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask$1;
var hostReportErrors = hostReportErrors$1;
var perform$2 = perform$3;
var Queue = queue;
var InternalStateModule = internalState;
var NativePromiseConstructor$2 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype$1 = NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;
var PromiseConstructor = NativePromiseConstructor$2;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$1 = global$2.TypeError;
var document$1 = global$2.document;
var process = global$2.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$3.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$2.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject$2(it) && isCallable$2(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError$1('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$6(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$2.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$2['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$6(task, global$2, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$2(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$6(task, global$2, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$1 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$6(then, value,
            bind$1(internalResolve, wrapper, state),
            bind$1(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable$3(executor);
    call$6(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$1(internalResolve, state), bind$1(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$1(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$2(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$2(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$1(internalResolve, state);
    this.reject = bind$1(internalReject, state);
  };

  newPromiseCapabilityModule$3.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$2(NativePromiseConstructor$2) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$1(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$6(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype$1, PromisePrototype);
    }
  }
}

$$9({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

var wellKnownSymbol$4 = wellKnownSymbol$g;
var Iterators$1 = iterators;

var ITERATOR$2 = wellKnownSymbol$4('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$2] === it);
};

var classof$2 = classof$6;
var getMethod$1 = getMethod$3;
var isNullOrUndefined = isNullOrUndefined$4;
var Iterators = iterators;
var wellKnownSymbol$3 = wellKnownSymbol$g;

var ITERATOR$1 = wellKnownSymbol$3('iterator');

var getIteratorMethod$2 = function (it) {
  if (!isNullOrUndefined(it)) return getMethod$1(it, ITERATOR$1)
    || getMethod$1(it, '@@iterator')
    || Iterators[classof$2(it)];
};

var call$5 = functionCall;
var aCallable$2 = aCallable$8;
var anObject$3 = anObject$a;
var tryToString$1 = tryToString$5;
var getIteratorMethod$1 = getIteratorMethod$2;

var $TypeError$2 = TypeError;

var getIterator$1 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1(argument) : usingIterator;
  if (aCallable$2(iteratorMethod)) return anObject$3(call$5(iteratorMethod, argument));
  throw $TypeError$2(tryToString$1(argument) + ' is not iterable');
};

var call$4 = functionCall;
var anObject$2 = anObject$a;
var getMethod = getMethod$3;

var iteratorClose$1 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$2(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$4(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$2(innerResult);
  return value;
};

var bind = functionBindContext;
var call$3 = functionCall;
var anObject$1 = anObject$a;
var tryToString = tryToString$5;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike = lengthOfArrayLike$4;
var isPrototypeOf$1 = objectIsPrototypeOf;
var getIterator = getIterator$1;
var getIteratorMethod = getIteratorMethod$2;
var iteratorClose = iteratorClose$1;

var $TypeError$1 = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$2 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$1(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError$1(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$1(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$3(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$1(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol$2 = wellKnownSymbol$g;

var ITERATOR = wellKnownSymbol$2('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var NativePromiseConstructor$1 = promiseNativeConstructor;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor$1.all(iterable).then(undefined, function () { /* empty */ });
});

var $$8 = _export;
var call$2 = functionCall;
var aCallable$1 = aCallable$8;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$3;
var iterate$1 = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$8({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$2($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$7 = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor = promiseNativeConstructor;
var getBuiltIn$1 = getBuiltIn$8;
var isCallable$1 = isCallable$l;
var defineBuiltIn = defineBuiltIn$5;

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$7({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable$1(NativePromiseConstructor)) {
  var method = getBuiltIn$1('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

var $$6 = _export;
var call$1 = functionCall;
var aCallable = aCallable$8;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform = perform$3;
var iterate = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$6({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call$1($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$5 = _export;
var call = functionCall;
var newPromiseCapabilityModule = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$5({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});

var anObject = anObject$a;
var isObject$1 = isObject$9;
var newPromiseCapability = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject(C);
  if (isObject$1(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var $$4 = _export;
var getBuiltIn = getBuiltIn$8;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve = promiseResolve$1;

getBuiltIn('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$$4({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

var $$3 = _export;
var $includes = arrayIncludes.includes;
var fails = fails$g;
var addToUnscopables = addToUnscopables$2;

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$3({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var classof$1 = classofRaw$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$1 = Array.isArray || function isArray(argument) {
  return classof$1(argument) == 'Array';
};

var $$2 = _export;
var uncurryThis$2 = functionUncurryThis;
var isArray = isArray$1;

var nativeReverse = uncurryThis$2([].reverse);
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$$2({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray(this)) this.length = this.length;
    return nativeReverse(this);
  }
});

/**
 *  Helper utility to verify if 'thing' is of type BreakPointCustomizable
 * @param thing
 */
function isBreakPointCustomizable(thing, ...things) {
  if (isThingBPCustomizable(thing)) {
    return true;
    // eslint-disable-next-line no-extra-boolean-cast
  } else if (!!things) {
    return things.find(t => isThingBPCustomizable(t)) !== undefined;
  } else {
    return false;
  }
}
function isThingBPCustomizable(thing) {
  if (thing === undefined || thing === null || typeof thing === 'string' || thing instanceof String) return false;
  // eslint-disable-next-line @typescript-eslint/ban-types
  const keys = Object.keys(thing);
  if (keys.length === 0) {
    return false;
  }
  const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl', '2xl'];
  let isBPCustomizable = false;
  keys.forEach(key => {
    if (breakpoints.includes(key)) {
      isBPCustomizable = true;
    }
  });
  return isBPCustomizable;
}
/**
 *
 * @param bpCustomizable Generates class names based on definition provided within bpCustomizable
 * @param prefixClass Optional string to be prefixed to the class names provided in the definition
 */
function constructClassNames(bpCustomizable, prefixClass = '', libPrefix = 'rbc') {
  const classNames = [];
  // eslint-disable-next-line @typescript-eslint/ban-types
  const keys = Object.keys(bpCustomizable);
  keys.forEach(bp => {
    const name = bpCustomizable[bp];
    classNames.push([libPrefix, prefixClass, `${name}--bp-${bp}`].filter(s => s !== '').join('-'));
  });
  return classNames;
}
/**
 *
 * @param prop The property used to generate class names
 * @param prefix Optional prefix for utility classes
 */
const generateBreakpointUtilityClasses = (prop, prefix = '', libPrefix = 'rbc') => {
  if (prop === null || prop === undefined) return [''];
  const classNames = [];
  if (isThingBPCustomizable(prop)) {
    classNames.push(...constructClassNames(prop, prefix, libPrefix));
  } else {
    classNames.push([libPrefix, prefix, prop].filter(s => s !== '').join('-'));
  }
  return classNames;
};
/**
 * Given a BreakpointCustomizable property, will return the correct value associated to the current viewports breakpoint.
 * @param prop The BreakpointCustomizable definition used to map Breakpoint: Value
 */
function getBreakpointValue(prop) {
  if (isThingBPCustomizable(prop)) {
    // eslint-disable-next-line @typescript-eslint/ban-types
    const foundBP = Object.keys(prop).reverse().find(bp => {
      return isBreakpointAtLeast(window.innerWidth, bp);
    });
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!foundBP) {
      return prop[foundBP];
    }
  } else {
    return prop;
  }
}
/**
 * Handles the non-falsiness of an empty array or empty object by returning a fallback if val is an empty array or an empty object
 * @param val Value to be checked
 * @param def Fallback if val is an empty object
 */
const checkEmptyObject = (val, def) => {
  const isArrayOrObject = val instanceof Array || val instanceof Object;
  return isArrayOrObject && Object.keys(val).length === 0 ? def : val;
};
/**
 * Performs check for empty objects and returns the value at a given breakpoint
 * @param val Value to be checked
 * @param def Fallback if val is an empty object
 */
const checkBpCustomizableAndReturn = (val, def) => {
  return isBreakPointCustomizable(val) ? getBreakpointValue(val) : checkEmptyObject(val, def);
};

const getBPValue$1 = prop => {
  return isBreakPointCustomizable(prop) ? getBreakpointValue(prop) : prop;
};
/**
 * @param children returns sorted ReactNode[] based on data attribute 'order'
 */
const sortElementsByOrder = children => {
  return children.sort((a, b) => {
    let orderA = 0,
      orderB = 0;
    if ( /*#__PURE__*/React.isValidElement(a) && /*#__PURE__*/React.isValidElement(b)) {
      orderA = getBPValue$1(a.props.order) || children.indexOf(a);
      orderB = getBPValue$1(b.props.order) || children.indexOf(b);
    }
    return orderA - orderB;
  });
};
/**
 * @param children will sort the DOM if 'data' attribute is present on 'children' elements.
 */
const sortDOMOrder = children => {
  const childrenArr = React.Children.toArray(children);
  return sortElementsByOrder(childrenArr);
};

const ColumnLayout = ({
  children
}) => {
  const [breakpoint] = useBreakPointService('xs');
  useEffect(() => {
    setSortedChildren(sortDOMOrder(children));
  }, [children, breakpoint]);
  const classes = classNames(['rbc-column-layout']);
  const [sortedChildren, setSortedChildren] = useState(sortDOMOrder(children));
  return jsx("div", {
    className: classes,
    children: sortedChildren
  });
};
/**
 * @deprecated Since 3.0.0-alpha.3. Use ColumnLayout instead of ColumnLayoutComponent
 */
const ColumnLayoutComponent = ColumnLayout;

const ColumnItem = ({
  columnOffset,
  columnWidth,
  children
}) => {
  const classes = classNames('rbc-column-item', generateBreakpointUtilityClasses(columnWidth, 'col'), generateBreakpointUtilityClasses(columnOffset, 'offset'));
  return jsx("div", {
    className: classes,
    children: children
  });
};
/**
 * @deprecated Since 3.0.0-alpha.3. Use ColumnItem instead of ColumnItemComponent
 */
const ColumnItemComponent = ColumnItem;

const FlexLayout = ({
  horizontalAlignment: _horizontalAlignment = 'left',
  verticalAlignment: _verticalAlignment = 'top',
  direction: _direction = 'horizontal',
  wrap: _wrap = false,
  spacingBetweenItems,
  children
}) => {
  const [breakpoint] = useBreakPointService('xs');
  useEffect(() => {
    setSortedChildren(sortDOMOrder(children));
  }, [children, breakpoint]);
  const classes = classNames('rbc-flex-layout', generateBreakpointUtilityClasses(_horizontalAlignment, 'h'), generateBreakpointUtilityClasses(_verticalAlignment, 'v'), generateBreakpointUtilityClasses(_direction, 'direction'), generateBreakpointUtilityClasses(_wrap, 'wrap'), generateBreakpointUtilityClasses(spacingBetweenItems, 'space-between'));
  const [sortedChildren, setSortedChildren] = useState(sortDOMOrder(children));
  return jsx("div", {
    className: classes,
    children: sortedChildren
  });
};
/**
 * @deprecated Since 3.0.0-alpha.3. Use FlexLayout instead of FlexLayoutComponent
 */
const FlexLayoutComponent = FlexLayout;

const updatePropValue = (updateFunction, prop) => {
  updateFunction(getBPValue(prop));
};
const getBPValue = prop => {
  return isBreakPointCustomizable(prop) ? getBreakpointValue(prop) : prop;
};
const FlexItem = ({
  verticalAlignment,
  horizontalAlignment,
  growFactor: _growFactor2 = 0,
  shrinkFactor: _shrinkFactor2 = 0,
  basisWidth: _basisWidth2 = 'auto',
  children
}) => {
  const [breakpoint] = useBreakPointService('xs');
  useEffect(() => {
    updatePropValue(setGrowFactor, _growFactor2);
    updatePropValue(setShrinkFactor, _shrinkFactor2);
    updatePropValue(setBasisWidth, _basisWidth2);
  }, [breakpoint, children]);
  const classes = classNames(['rbc-flex-item'], generateBreakpointUtilityClasses(horizontalAlignment, 'h'), generateBreakpointUtilityClasses(verticalAlignment, 'v'));
  const [_growFactor, setGrowFactor] = useState(getBPValue(_growFactor2));
  const [_shrinkFactor, setShrinkFactor] = useState(getBPValue(_shrinkFactor2));
  const [_basisWidth, setBasisWidth] = useState(getBPValue(_basisWidth2));
  const styles = {
    flex: `${_growFactor} ${_shrinkFactor} ${_basisWidth}`
  };
  return jsx("div", {
    style: Object.assign({}, styles),
    className: classes,
    children: children
  });
};
/**
 * @deprecated Since 3.0.0-alpha.3. Use FlexItem instead of FlexItemComponent
 */
const FlexItemComponent = FlexItem;

const LayoutContainer = ({
  kind: _kind = 'fixed',
  background,
  hasMargins,
  children
}) => {
  const classes = classNames(['rbc-layout-container', `rbc-${_kind}`, {
    [`rbc-bg-${background}`]: !!background
  }, generateBreakpointUtilityClasses(hasMargins, 'margins')]);
  return jsx("div", {
    className: classes,
    children: jsx("div", {
      className: "rbc-layout-container-content",
      children: children
    })
  });
};

function useLockScroll(open) {
  const overflow = useRef(window.getComputedStyle(document.body).overflow);
  useLayoutEffect(() => {
    if (open) {
      overflow.current = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = overflow.current;
    }
  }, [open]);
}

const setPlacement = (targetElement, placementElement, options = {}) => {
  const rect = targetElement.getBoundingClientRect();
  const contentRect = placementElement.getBoundingClientRect();
  const {
    offset
  } = options;
  // eslint-disable-next-line no-extra-boolean-cast
  const offsetHeight = !!(offset && offset.height) ? offset.height : 0;
  const bottomHeight = window.innerHeight - rect.bottom;
  const rightWidth = window.innerWidth - rect.right;
  const contentRightWidth = window.innerWidth - (rect.left + contentRect.width);
  if (rect.top > bottomHeight) {
    setBottomPlacement(placementElement, bottomHeight + offsetHeight);
  } else {
    setTopPlacement(placementElement, rect.top + offsetHeight);
  }
  if (rect.left > rightWidth || rect.left === rightWidth && rect.left > contentRightWidth) {
    setRightPlacement(placementElement, rightWidth);
  } else {
    setLeftPlacement(placementElement, rect.left);
  }
};
const setTopPlacement = (element, value) => {
  element.style.bottom = '';
  element.style.top = `${value}px`;
};
const setBottomPlacement = (element, value) => {
  element.style.top = '';
  element.style.bottom = `${value}px`;
};
const setLeftPlacement = (element, value) => {
  element.style.right = '';
  element.style.left = `${value}px`;
};
const setRightPlacement = (element, value) => {
  element.style.left = '';
  element.style.right = `${value}px`;
};
const clearPlacements = element => {
  element.style.top = '';
  element.style.right = '';
  element.style.bottom = '';
  element.style.left = '';
};

const _excluded$i = ["position", "open", "size", "role", "showScrim", "onClose", "initiator", "children"];
const RBCPanel = _ref => {
  let {
      position,
      open = false,
      size = 'auto',
      role = 'dialog',
      showScrim = true,
      onClose,
      initiator,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$i);
  const [breakPoints] = useBreakPointService(Breakpoint.small);
  const panelContentElement = useRef(null);
  const panelElement = useRef(null);
  const sizeStyling = getSizeStyling(size, position);
  useLockScroll(open && showScrim);
  useLayoutEffect(() => {
    const initiatorElement = document.getElementById(initiator);
    const panelContent = panelContentElement.current;
    if (initiatorElement && panelContent && (position === PanelPosition.inlineAdjacent || position === PanelPosition.inlineOccluding)) {
      const rect = initiatorElement.getBoundingClientRect();
      const offsetHeight = position === 'inline-adjacent' ? rect.height : 0;
      setPlacement(initiatorElement, panelContent, {
        offset: {
          height: offsetHeight
        }
      });
    }
  }, [open, position, breakPoints]);
  const closePanel = event => {
    if (event.key === 'Esc' || event.key === 'Escape') {
      event.preventDefault();
      onClose();
    }
  };
  const classes = classNames('rbc-panel', {
    'rbc-panel-open': open === true,
    'rbc-panel-closed': open === false,
    'rbc-panel-center': position === PanelPosition.center || position === undefined,
    'rbc-panel-left': position === PanelPosition.left,
    'rbc-panel-right': position === PanelPosition.right,
    'rbc-panel-bottom': position === PanelPosition.bottom,
    'rbc-panel-top': position === PanelPosition.top,
    'rbc-panel-inline': position === PanelPosition.inlineAdjacent || position === PanelPosition.inlineOccluding
  });
  return jsxs("div", {
    className: `${classes}`,
    ref: panelElement,
    onKeyDown: closePanel,
    children: [showScrim && jsx("div", {
      className: "rbc-panel-scrim",
      onClick: onClose
    }), jsx("div", Object.assign({
      className: "rbc-panel-content",
      role: role,
      ref: panelContentElement,
      style: sizeStyling
    }, props, {
      children: open && jsx(FocusScope, {
        contain: true,
        autoFocus: true,
        restoreFocus: true,
        children: children
      })
    }))]
  });
};
function getSizeStyling(size, position) {
  const axisStyle = {
    [PanelPosition.bottom]: 'height',
    [PanelPosition.top]: 'height',
    [PanelPosition.left]: 'width',
    [PanelPosition.right]: 'width'
  };
  const widthOrHeight = axisStyle[position];
  if (widthOrHeight) {
    return {
      [widthOrHeight]: size
    };
  } else {
    return {};
  }
}

const _excluded$h = ["direction", "dividerBetween", "dividerCap", "distributeEvenly", "role", "children", "className"];
const Stack = _ref => {
  let {
      direction,
      dividerBetween,
      dividerCap,
      distributeEvenly = false,
      role,
      children,
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$h);
  const dividerDirection = direction === 'horizontal' ? 'vertical' : 'horizontal';
  const renderChildren = () => {
    const childrenLength = React.Children.count(children) - 1;
    const result = React.Children.map(children, (child, index) => {
      return jsxs(Fragment, {
        children: [jsx("div", {
          className: `rbc-stack-item rbc-stack-space-between item-${index}`,
          "data-cy-id": `item-${index}`,
          children: child
        }, `item-${index}`), index < childrenLength && dividerBetween && jsx(Divider, {
          direction: dividerDirection,
          thickness: dividerBetween
        }, `divider-${index}`)]
      });
    });
    return result || [];
  };
  const classes = classNames('rbc-stack', {
    'rbc-stack-vertical': direction === undefined || direction === 'vertical',
    'rbc-stack-horizontal': direction === 'horizontal',
    'rbc-stack-distribute-evenly': distributeEvenly === true
  });
  const wrapperClasses = classNames('rbc-stack-wrapper', className, {
    'rbc-stack-vertical': direction === undefined || direction === 'vertical',
    'rbc-stack-horizontal': direction === 'horizontal'
  });
  return jsx(Fragment, {
    children: jsxs("div", Object.assign({
      className: wrapperClasses,
      "data-cy-id": "stack"
    }, props, {
      children: [dividerCap && jsx("div", {
        className: "dividercap__top",
        children: jsx(Divider, {
          direction: dividerDirection,
          thickness: dividerCap
        })
      }), jsx("div", {
        className: classes,
        role: role,
        children: renderChildren()
      }), dividerCap && jsx("div", {
        className: "dividercap__bottom",
        children: jsx(Divider, {
          direction: dividerDirection,
          thickness: dividerCap
        })
      })]
    }))
  });
};

const Copy = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    copyElement,
    copyContent
  } = props;
  const [copyMessage, setCopyMessage] = useState('');
  const classes = classNames('copy-message', {
    visible: copyMessage !== ''
  });
  const copy = () => {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = copyContent ? copyContent : (copyElement == null ? void 0 : copyElement.innerText) || '';
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    setCopyMessage('Coppied');
    setTimeout(() => {
      setCopyMessage('');
    }, 1000);
  };
  return jsxs("button", {
    className: "copy-code-btn",
    onClick: copy,
    children: [jsxs("span", {
      className: classes,
      children: [" ", copyMessage]
    }), jsxs("svg", {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [jsx("path", {
        d: "M7.79647 27.9999H21.1447C22.1365 27.9999 22.9412 27.1952 22.9412 26.2034V9.32577C22.9412 8.334 22.1365 7.5293 21.1447 7.5293H7.79647C6.80471 7.5293 6 8.334 6 9.32577V26.2034C6 27.1952 6.80471 27.9999 7.79647 27.9999ZM7.41176 9.32577C7.41176 9.114 7.58471 8.94106 7.79647 8.94106H21.1447C21.3565 8.94106 21.5294 9.114 21.5294 9.32577V26.2034C21.5294 26.4152 21.3565 26.5881 21.1447 26.5881H7.79647C7.58471 26.5881 7.41176 26.4152 7.41176 26.2034V9.32577Z",
        fill: "#444444"
      }), jsx("path", {
        d: "M24.674 4H11.3258C10.334 4 9.5293 4.80471 9.5293 5.79647C9.5293 6.18471 9.84694 6.50235 10.2352 6.50235C10.6234 6.50235 10.9411 6.18471 10.9411 5.79647C10.9411 5.58471 11.114 5.41176 11.3258 5.41176H24.674C24.8858 5.41176 25.0587 5.58471 25.0587 5.79647V22.6741C25.0587 22.8859 24.8858 23.0588 24.674 23.0588C24.2858 23.0588 23.9681 23.3765 23.9681 23.7647C23.9681 24.1529 24.2858 24.4706 24.674 24.4706C25.6658 24.4706 26.4705 23.6659 26.4705 22.6741V5.79647C26.4705 4.80471 25.6658 4 24.674 4Z",
        fill: "#444444"
      })]
    })]
  });
});

const _excluded$g = ["priority", "mode", "size", "className", "children"];
const CTA = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      priority,
      mode,
      size,
      className,
      children
    } = props,
    btnProps = _objectWithoutPropertiesLoose(props, _excluded$g);
  const classes = classNames('rbc-cta', {
    'rbc-cta--secondary': priority === 'secondary',
    'rbc-cta--tertiary': priority === 'tertiary',
    'rbc-cta--accent': priority === 'accent',
    'rbc-cta--dark': mode === 'dark',
    'rbc-cta--small': size === 'small'
  }, className);
  return jsx("button", Object.assign({
    ref: ref,
    className: classes,
    type: "button"
  }, btnProps, {
    children: children
  }));
});

var isObject = isObject$9;
var classof = classofRaw$2;
var wellKnownSymbol$1 = wellKnownSymbol$g;

var MATCH$1 = wellKnownSymbol$1('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};

var isRegExp = isRegexp;

var $TypeError = TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw $TypeError("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol = wellKnownSymbol$g;

var MATCH = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$1 = _export;
var uncurryThis$1 = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$3;
var toString$1 = toString$3;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf = uncurryThis$1(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$1({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString$1(requireObjectCoercible(this)),
      toString$1(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

const defaultLocale = typeof navigator !== 'undefined' && navigator.language || 'en-US';
const I18nContext = /*#__PURE__*/React.createContext({
  locale: defaultLocale
});
/**
 * Provides the locale for the application to all child components.
 */
function I18nProvider({
  i18nConfig,
  children
}) {
  const i18nFromContext = useContext(I18nContext);
  return jsx(I18nContext.Provider, {
    value: Object.assign({}, i18nFromContext, i18nConfig),
    children: children
  });
}
function useLocale() {
  return useContext(I18nContext).locale;
}

const _excluded$f = ["url", "elementType"];
const DefaultLinkComponent = _ref => {
  let {
      url
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$f);
  return jsx("a", Object.assign({
    href: url
  }, props));
};
const LinkComponentContext = /*#__PURE__*/createContext(DefaultLinkComponent);
const useLinkComponent = () => {
  return useContext(LinkComponentContext);
};
const LinkComponentProvider = ({
  linkComponent,
  children
}) => {
  const linkComponentFromContext = useContext(LinkComponentContext);
  return jsx(LinkComponentContext.Provider, {
    value: linkComponent || linkComponentFromContext,
    children: children
  });
};

const _excluded$e = ["elementType", "srLabel", "destinationType", "className", "children", "url", "type"];
const Button = /*#__PURE__*/React.forwardRef((props, ref) => jsx("button", Object.assign({}, props, {
  ref: ref
})));
const Clickable = /*#__PURE__*/React.forwardRef((props, ref) => {
  const isEnglish = useLocale().includes('en');
  const {
    rel,
    target,
    destinationA11yLabel
  } = getLinkAttributesFromDestinationType(props.destinationType, isEnglish);
  const LinkComponent = useLinkComponent();
  const {
      elementType = 'link',
      srLabel,
      className,
      children,
      type
    } = props,
    extras = _objectWithoutPropertiesLoose(props, _excluded$e);
  // Type guards hint to typescript when only button/link props will be used
  const isLinkType = allProps => allProps.elementType === 'link' || allProps.elementType === 'router-link' || !allProps.elementType;
  const handleClick = () => {};
  const isButtonType = allProps => allProps.elementType === 'button';
  // TODO: TS 4.6 adds support for Control Flow Analysis on destructured elements. We might be able to use the destructured url, rel, and target
  if (isLinkType(props)) {
    return jsxs(LinkComponent, {
      "aria-label": srLabel,
      url: props.url,
      className: className,
      elementType: elementType,
      rel: props.rel,
      target: props.target,
      children: [children, jsx("span", {
        className: "rbc-sr-only",
        children: destinationA11yLabel
      })]
    });
  } else if (isButtonType(props)) {
    const {
      onClick
    } = props;
    return jsx(Button, Object.assign({
      ref: ref,
      onClick: onClick,
      "aria-label": srLabel,
      type: type || 'button'
    }, extras, {
      children: children
    }));
  } else {
    return jsx(Button, Object.assign({
      onClick: handleClick
    }, props, {
      children: children
    }));
  }
});

var $ = _export;
var DESCRIPTORS = descriptors;
var global$1 = global$k;
var uncurryThis = functionUncurryThis;
var hasOwn = hasOwnProperty_1;
var isCallable = isCallable$l;
var isPrototypeOf = objectIsPrototypeOf;
var toString = toString$3;
var defineProperty = objectDefineProperty.f;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$1.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineProperty(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

class SvgUtils {
  static cloneSvg(svg) {
    return svg.cloneNode(true);
  }
  static emptySvg() {
    return SvgUtils$1.createEmptySvg(document);
  }
  static setSvgAttributes(svg) {
    svg.setAttribute('fit', '');
    svg.setAttribute('height', '100%');
    svg.setAttribute('width', '100%');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    svg.setAttribute('focusable', 'false'); // Disable IE11 default behavior to make SVGs focusable.
    return svg;
  }
  static getIconNameNotFound(iconName) {
    return Error(`Unable to find icon with the name '${iconName}'`);
  }
  static getFailedToSanitizeUrlError(url) {
    return Error(`The URL provided to RBC Icon was not trusted as a resource URL ` + `via Angular's DomSanitizer. Attempted URL was '${url}'.`);
  }
  static iconKey(name, size) {
    return `${name}:${SvgUtils.getMapPath(size)}`;
  }
  static getMapPath(size) {
    switch (size) {
      case 'sm':
      case 's':
      case 'md':
        return 'sm';
      case 'm':
      case 'lg':
        return 'md';
      case 'l':
      case 'xl':
        return 'lg';
      default:
        if (typeof size === 'number') {
          if (size <= 31) {
            return 'sm';
          } else if (size <= 48) {
            return 'md';
          } else {
            return 'lg';
          }
        }
        return 'sm';
    }
  }
  static svgElementFromString(str, div) {
    div.innerHTML = str;
    const svg = div.querySelector('svg');
    if (!svg) {
      throw Error('<svg> tag not found');
    }
    return svg;
  }
  static getPath(size) {
    switch (SvgUtils.getMapPath(size)) {
      case 'md':
        return '-md';
      case 'lg':
        return '-lg';
      default:
        return '';
    }
  }
  static clearStyleTags(svg) {
    const styleTags = svg.querySelectorAll('style');
    for (let i = 0; i < styleTags.length; i++) {
      styleTags[i].textContent += ' ';
    }
    return svg;
  }
  static addAccessibiltyLabels(svg, label, description) {
    const titleElement = new HTMLTitleElement();
    titleElement.innerHTML = label;
    svg.append(titleElement);
    if (description) {
      svg.innerHTML = `<desc></desc>${svg.innerHTML}`;
    }
    return svg;
  }
}

const FEATURE_NAME = 'icon-feature/media';
const MAP_PATH = 'sprites/symbol';
const defaultConfiguration = {
  assetPath: './assets',
  type: 'common'
};
class IconRegistry {
  constructor(config) {
    this.svgIconConfigs = new Map();
    this.iconSetConfigs = new Map();
    this.spriteMaps = [];
    this.configuration = defaultConfiguration;
    if (config) {
      this.configuration = config;
    }
  }
  isCommonPath() {
    return this.configuration.type === 'common';
  }
  getIconFromSet(name, size) {
    let config = this.iconSetConfigs.get(SvgUtils.iconKey(name, size));
    if (!config) {
      let url;
      if (!this.isCommonPath()) {
        url = `${this.configuration.assetPath}/svg/sprite-${SvgUtils.getMapPath(size)}.svg`;
      } else {
        url = `${this.configuration.assetPath}/${FEATURE_NAME}/${MAP_PATH}/svg/sprite-${SvgUtils.getMapPath(size)}.svg`;
      }
      this.iconSetConfigs.set(SvgUtils.iconKey(name, size), {
        url: url,
        svgElement: undefined
      });
      config = this.iconSetConfigs.get(SvgUtils.iconKey(name, size));
    }
    return this.getSvgIconFromSetConfig(`${name}${SvgUtils.getPath(size)}`, size, config);
  }
  getSingleIcon(name, size) {
    let config = this.svgIconConfigs.get(SvgUtils.iconKey(name, size));
    if (!config) {
      let url;
      if (!this.isCommonPath()) {
        url = `${this.configuration.assetPath}/svg/${name}${SvgUtils.getPath(size)}.svg`;
      } else {
        url = `${this.configuration.assetPath}/${FEATURE_NAME}/svg/${name}${SvgUtils.getPath(size)}.svg`;
      }
      this.svgIconConfigs.set(SvgUtils.iconKey(name, size), {
        url: url,
        svgElement: undefined
      });
      config = this.svgIconConfigs.get(SvgUtils.iconKey(name, size));
    }
    return this.getSvgIconFromConfig(config);
  }
  setSpriteMap(size, promise) {
    this.spriteMaps.push({
      size,
      promise
    });
  }
  getSvgIconFromSetConfig(name, size, config) {
    if (config != null) {
      if (config.svgElement) {
        return Promise.resolve(this.extractSvgIconFromSet(config.svgElement, name));
      } else if (config.url) {
        const currentSizeSpriteMap = this.spriteMaps.find(arr => arr.size === size);
        const spriteRequest = currentSizeSpriteMap ? currentSizeSpriteMap.promise : axios.get(config.url, Object.assign({
          responseType: 'text'
        }, this.configuration.axiosConfig)).then(response => response.status === 200 ? Promise.resolve(response.data || '') : Promise.reject());
        if (!currentSizeSpriteMap) {
          this.setSpriteMap(size, spriteRequest);
        }
        return spriteRequest.then(response => {
          if (response != null) {
            const svg = SvgUtils.svgElementFromString(response, document.createElement('DIV'));
            config.svgElement = svg;
            return this.extractSvgIconFromSet(svg, name);
          } else {
            return SvgUtils.emptySvg();
          }
        });
      }
    }
    return Promise.resolve(SvgUtils.emptySvg());
  }
  getSvgIconFromConfig(config) {
    if (config) {
      if (config.svgElement) {
        return Promise.resolve(SvgUtils.cloneSvg(config.svgElement));
      } else {
        return axios.get(config.url, Object.assign({
          responseType: 'text'
        }, this.configuration.axiosConfig)).then(response => response.status === 200 ? Promise.resolve(response.data) : Promise.reject()).then(response => {
          const svg = SvgUtils.svgElementFromString(response, document.createElement('DIV'));
          return SvgUtils.setSvgAttributes(svg);
        }).then(svg => {
          config.svgElement = svg;
          return SvgUtils.cloneSvg(svg);
        });
      }
    }
    return Promise.resolve(SvgUtils.emptySvg());
  }
  extractSvgIconFromSet(iconSet, iconName) {
    // Use the `id="iconName"` syntax in order to escape special
    // characters in the ID (versus using the #iconName syntax).
    const iconSource = iconSet.querySelector(`[id="${iconName}"]`);
    if (!iconSource) {
      throw SvgUtils.getIconNameNotFound(iconName);
    }
    // Clone the element and remove the ID to prevent multiple elements from being added
    // to the page with the same ID.
    const iconElement = iconSource.cloneNode(true);
    iconElement.removeAttribute('id');
    // If the icon node is itself an <svg> node, clone and return it directly. If not, set it as
    // the content of a new <svg> node.
    if (iconElement.nodeName.toLowerCase() === 'svg') {
      return SvgUtils.setSvgAttributes(iconElement);
    }
    // If the node is a <symbol>, it won't be rendered so we have to convert it into <svg>. Note
    // that the same could be achieved by referring to it via <use href="#id">, however the <use>
    // tag is problematic on Firefox, because it needs to include the current page path.
    if (iconElement.nodeName.toLowerCase() === 'symbol') {
      return SvgUtils.setSvgAttributes(this.toSvgElement(iconElement));
    }
    // createElement('SVG') doesn't work as expected; the DOM ends up with
    // the correct nodes, but the SVG content doesn't render. Instead we
    // have to create an empty SVG node using innerHTML and append its content.
    // Elements created using DOMParser.parseFromString have the same problem.
    // http://stackoverflow.com/questions/23003278/svg-innerhtml-in-firefox-can-not-display
    const svg = this.createEmptySvg();
    // Clone the node so we don't remove it from the parent icon set element.
    svg.appendChild(iconElement);
    return SvgUtils.setSvgAttributes(svg);
  }
  createEmptySvg() {
    const div = document.createElement('DIV');
    return SvgUtils.svgElementFromString('<svg></svg>', div);
  }
  toSvgElement(element) {
    const svg = this.createEmptySvg();
    // Copy the viewbox to maintain sizing
    if (element.hasAttribute('viewBox')) {
      svg.setAttribute('viewBox', element.getAttribute('viewBox') || '');
    }
    for (let i = 0; i < element.childNodes.length; i++) {
      if (element.childNodes[i].nodeType === document.ELEMENT_NODE) {
        svg.appendChild(element.childNodes[i].cloneNode(true));
      }
    }
    return svg;
  }
}
let registry;
const createIconRegistry = config => {
  registry = new IconRegistry(config);
  return registry;
};
const iconRegistry = config => registry || createIconRegistry(config);

const IconRegistryContext = /*#__PURE__*/React.createContext(defaultConfiguration);
const IconRegistryProvider = IconRegistryContext.Provider;
function getSvg(token, size, label, description, config) {
  return iconRegistry(config).getSingleIcon(token, size).then(svg => {
    return addA11ytoSVG(svg, label, description);
  });
}
function addA11ytoSVG(svg, label, description) {
  if (svg && label) {
    const title = document.createElement('title');
    title.innerHTML = label;
    svg.appendChild(title);
    if (description) {
      const desc = document.createElement('desc');
      desc.innerHTML = description;
      svg.appendChild(desc);
    }
  }
  return svg;
}
function getSvgFromMap(token, size, label, description, config) {
  return iconRegistry(config).getIconFromSet(token, size).then(svg => {
    if (svg) {
      return addA11ytoSVG(svg, label, description);
    }
    return svg;
  });
}
const RBCIcon = props => {
  const {
    token,
    useSprites,
    decorative,
    className,
    label,
    description
  } = props;
  let {
    size
  } = props;
  size = size || 's';
  const [svg, setSvg] = useState(undefined);
  const config = useContext(IconRegistryContext);
  useEffect(() => {
    let promise;
    try {
      if (useSprites === undefined || useSprites === true) {
        promise = getSvgFromMap(token, size, label, description, config);
      } else {
        promise = getSvg(token, size, label, description, config);
      }
      promise.then(data => {
        if (data) {
          setSvg(data.outerHTML);
        }
      });
    } catch (_unused) {}
  });
  let styles = {};
  if (typeof size === 'number') {
    styles = {
      height: size,
      width: size,
      minHeight: size,
      minWidth: size
    };
  }
  const classes = classNames('rbc-icon', token, {
    s: size === 's',
    m: size === 'm',
    l: size === 'l'
  }, className);
  return jsx("div", {
    "aria-hidden": decorative !== false,
    className: classes,
    style: styles,
    dangerouslySetInnerHTML: {
      __html: svg || ''
    }
  });
};

const _excluded$d = ["density", "icon", "children"];
const CTAText = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      density,
      icon,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$d);
  const {
    destinationIcon
  } = getLinkAttributesFromDestinationType(props.destinationType);
  const classes = classNames('rbc-cta-text', {
    'rbc-cta-text--density-compact': density === 'compact',
    'rbc-cta-text--density-comfortable': density === 'comfortable'
  });
  const prefixIconClasses = classNames('rbc-cta-text__prefix-icon', {
    'rbc-cta-text__prefix-icon--density-comfortable': density === 'comfortable'
  });
  const destinationIconClass = classNames({
    'rbc-cta-text__destination-icon': destinationIcon !== 'angle-right',
    'rbc-cta-text__destination-icon--indicator': destinationIcon === 'angle-right'
  });
  const iconSize = CTATextIconSizeMap[density || 'default'];
  return jsxs(Clickable, Object.assign({}, props, {
    ref: ref,
    className: classes,
    children: [icon && jsx(RBCIcon, {
      className: prefixIconClasses,
      size: iconSize,
      token: icon,
      decorative: true
    }), children, destinationIcon && jsx(RBCIcon, {
      className: destinationIconClass,
      size: destinationIcon === 'angle-right' ? 20 : 16,
      token: destinationIcon,
      decorative: true
    })]
  }));
});

const _excluded$c = ["state", "mode", "children", "type", "placeholder", "className"];
const Input = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      state,
      mode,
      type = 'text',
      placeholder = 'placeholder',
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$c);
  const classes = classNames('rbc-input', {
    'rbc-input--error': state === 'error',
    'rbc-input--dark': mode === 'dark'
  }, className);
  return jsx("input", Object.assign({
    type: type,
    placeholder: placeholder,
    className: classes,
    ref: ref
  }, props));
});

const _excluded$b = ["htmlFor", "id", "children", "className"];
const Label = _ref => {
  let {
      htmlFor,
      id,
      children,
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  const existingClass = className ? ' ' + className : '';
  return jsx("label", Object.assign({
    htmlFor: htmlFor,
    className: `rbc-form-label${existingClass}`,
    id: id
  }, props, {
    children: children
  }));
};

const getMappedTokens = value => {
  return value.split(' ').map(val => spacingTokens.get(val)).join(' ');
};

function useWindowSize() {
  const isClient = typeof window === 'object';
  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined
    };
  }
  const [windowSize, setWindowSize] = useState(getSize);
  useEffect(() => {
    if (!isClient) {
      return false;
    }
    function handleResize() {
      setWindowSize(getSize());
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
}

const KeyValueListContext = /*#__PURE__*/React.createContext({
  densityComputed: 'default',
  reduceKeySizeComputed: true,
  emphasis: 'value',
  itemSpacingComputed: 'z',
  kindComputed: 'stacked',
  keyHorizontalSizeComputed: 50,
  numberOfItems: undefined
});
const KeyValueList = ({
  /* API props start */
  kind,
  density,
  reduceKeySize,
  emphasis,
  keyHorizontalSize,
  dividerBetween,
  dividerCap,
  itemSpacing,
  listPadding,
  srLabel,
  /* API props end */
  children
}) => {
  useWindowSize();
  const numberOfItems = React.Children.count(children);
  const kvListClass = classNames('rbc-key-value-list-rw');
  const keyValueList = useRef(null);
  const [kindComputed, setKindComputed] = useState();
  const [densityComputed, setDensityComputed] = useState();
  const [reduceKeySizeComputed, setReduceKeySizeComputed] = useState();
  const [keyHorizontalSizeComputed, setKeyHorizontalSizeComputed] = useState();
  const [dividerBetweenComputed, setDividerBetweenComputed] = useState();
  const [dividerCapComputed, setDividerCapComputed] = useState();
  const [itemSpacingComputed, setItemSpacingComputed] = useState();
  const [listPaddingComputed, setListPaddingComputed] = useState(checkBpCustomizableAndReturn(listPadding) || KeyValueList.defaultProps['listPadding']);
  const computePadding = padding => {
    keyValueList.current.removeAttribute('style');
    const mappedPadding = getMappedTokens(padding);
    keyValueList.current.style.padding = `${mappedPadding}`;
  };
  useEffect(() => {
    var _checkBpCustomizableA;
    setKindComputed(checkBpCustomizableAndReturn(kind) || KeyValueList.defaultProps['kind']);
    setDensityComputed(checkBpCustomizableAndReturn(density) || KeyValueList.defaultProps['density']);
    setReduceKeySizeComputed((_checkBpCustomizableA = checkBpCustomizableAndReturn(reduceKeySize)) != null ? _checkBpCustomizableA : KeyValueList.defaultProps['reduceKeySize']);
    setDividerBetweenComputed(checkBpCustomizableAndReturn(dividerBetween) || KeyValueList.defaultProps['dividerBetween']);
    setDividerCapComputed(checkBpCustomizableAndReturn(dividerCap) || KeyValueList.defaultProps['dividerCap']);
    setItemSpacingComputed(checkBpCustomizableAndReturn(itemSpacing) || KeyValueList.defaultProps['itemSpacing']);
    setListPaddingComputed(checkBpCustomizableAndReturn(listPadding) || KeyValueList.defaultProps['listPadding']);
    setKeyHorizontalSizeComputed(checkBpCustomizableAndReturn(keyHorizontalSize) || KeyValueList.defaultProps['keyHorizontalSize']);
    computePadding(listPaddingComputed);
  });
  const value = {
    densityComputed,
    reduceKeySizeComputed,
    emphasis,
    kindComputed,
    keyHorizontalSizeComputed,
    dividerCapComputed,
    dividerBetweenComputed,
    itemSpacingComputed,
    numberOfItems
  };
  return jsxs(Fragment, {
    children: [dividerCapComputed && jsx(Divider, {
      thickness: dividerCapComputed
    }), jsx("ul", {
      ref: keyValueList,
      "aria-label": srLabel,
      className: kvListClass,
      children: jsx(KeyValueListContext.Provider, {
        value: value,
        children: React.Children.map(children, (Child, i) => {
          if ( /*#__PURE__*/React.isValidElement(Child)) {
            return jsxs("li", {
              className: 'rbc-key-value-item-li',
              children: [jsx(Child.type, Object.assign({}, Child.props, {
                position: i
              })), dividerBetweenComputed && i !== React.Children.toArray(children).length - 1 && jsx(Divider, {
                thickness: dividerBetweenComputed
              })]
            });
          }
          return null;
        })
      })
    }), dividerCapComputed && jsx(Divider, {
      thickness: dividerCapComputed
    })]
  });
};
KeyValueList.defaultProps = {
  kind: KIND.STACKED,
  density: 'default',
  reduceKeySize: true,
  emphasis: 'value',
  keyHorizontalSize: 50,
  itemSpacing: '2xs',
  listPadding: 'z'
};

const MenuGroup = ({
  label,
  children,
  headingLevel
}) => {
  const distributeEvenly = false;
  const dividerBetween = 'sm';
  return jsxs("div", {
    className: "rbc-menu-group",
    children: [jsx("div", {
      className: "rbc-menu-group-heading",
      role: "heading",
      "aria-level": Number(headingLevel) || 1,
      children: label
    }), jsx(Stack, {
      role: "list",
      direction: "vertical",
      distributeEvenly: distributeEvenly,
      dividerBetween: dividerBetween,
      children: children
    })]
  });
};

const _excluded$a = ["target", "selected", "prefixIcon", "suffixIcon", "srLabel", "itemId", "src", "text", "description", "notification", "onClick"];
const stateHook = (target, suffixIcon) => {
  const [targetAttr, setTargetAttr] = useState(undefined);
  const [relAttr, setRelAttr] = useState(undefined);
  const [displaySuffix, setDisplaySuffix] = useState(suffixIcon);
  const setPreset = (targ, setRel, suffix) => {
    setTargetAttr(targ);
    setRelAttr(setRel);
    setDisplaySuffix(suffix);
  };
  useEffect(() => {
    switch (target) {
      case 'child':
        setPreset(undefined, undefined, 'chevron-right');
        break;
      case 'external':
        setPreset('_blank', 'noopener', 'external-link');
        break;
      case 'internal-new-tab':
        setPreset('_blank', 'noopener', 'popup');
        break;
      case 'internal':
      case null:
      case 'none':
        setPreset(undefined, undefined, suffixIcon);
        break;
      default:
        throw new Error(`Invalid Input: ${target} is not a known value of target.`);
    }
  }, [target, suffixIcon]);
  return {
    targetAttr,
    relAttr,
    displaySuffix
  };
};
const MenuItemContent = ({
  prefix,
  text,
  description,
  suffix,
  notification
}) => {
  return jsxs(React.Fragment, {
    children: [prefix && jsx("span", {
      className: "rbc-menu-item-icon-prefix",
      children: jsx(RBCIcon, {
        token: prefix,
        size: "s",
        decorative: true
      })
    }), jsxs("div", {
      className: "rbc-menu-item-content",
      children: [jsx("span", {
        className: "rbc-menu-item__text",
        children: text
      }), description ? jsx("span", {
        className: "rbc-menu-item__description",
        children: description
      }) : null]
    }), suffix && jsx("span", {
      className: "rbc-menu-item-icon-suffix",
      children: jsx(RBCIcon, {
        token: suffix,
        size: "s",
        decorative: true
      })
    }), notification && jsx("span", {
      className: "rbc-menu-item__badge-notification",
      children: notification
    })]
  });
};
const MenuItem = _ref => {
  let {
      target = 'internal',
      selected = false,
      prefixIcon,
      suffixIcon,
      srLabel,
      itemId,
      src,
      text,
      description,
      notification,
      onClick
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$a);
  const {
    targetAttr,
    relAttr,
    displaySuffix
  } = stateHook(target, suffixIcon);
  const classes = classNames('rbc-menu-item', {
    'rbc-menu-item-selected': selected
  });
  const content = jsx(MenuItemContent, {
    prefix: prefixIcon,
    text: text,
    description: description,
    suffix: displaySuffix,
    notification: notification
  });
  return jsx("div", {
    className: classes,
    role: "listitem",
    children: target === 'child' || target === 'none' ? jsx("button", Object.assign({}, props, {
      className: "rbc-menu-item-link",
      type: "button",
      id: itemId,
      "aria-label": srLabel,
      onClick: onClick,
      children: content
    })) : jsx("a", Object.assign({}, props, {
      className: "rbc-menu-item-link",
      id: itemId,
      target: targetAttr,
      rel: relAttr,
      "aria-label": srLabel,
      href: src,
      children: content
    }))
  });
};

const MenuItemExpandable = ({
  expanded: _expanded = false,
  disableCollapse: _disableCollapse = false,
  prefixIcon,
  srLabel,
  itemId,
  children,
  text,
  description,
  notification,
  onClick
}) => {
  const listId = useId();
  return jsxs("div", {
    className: _expanded || _disableCollapse ? 'rbc-menu-item--expanded' : '',
    role: "listitem",
    children: [!_disableCollapse && jsx("div", {
      className: "rbc-menu-item",
      children: jsx("button", {
        className: "rbc-menu-item-link",
        type: "button",
        id: itemId,
        "aria-label": srLabel,
        "aria-expanded": _expanded,
        "aria-controls": listId,
        onClick: onClick,
        children: jsx(MenuItemContent, {
          prefix: prefixIcon,
          text: text,
          description: description,
          notification: notification,
          suffix: _expanded ? 'chevron-up' : 'chevron-down'
        })
      })
    }), _disableCollapse && jsx("div", {
      role: "heading",
      "aria-level": 3,
      className: "rbc-menu-item rbc-menu-item--disable-collapse",
      children: jsx(MenuItemContent, {
        prefix: prefixIcon,
        text: text,
        description: description,
        notification: notification
      })
    }), jsx("div", {
      role: "list",
      id: listId,
      className: "rbc-menu-item-expanded__children",
      hidden: !_expanded && !_disableCollapse,
      children: (_expanded || _disableCollapse) && children
    })]
  });
};

const _excluded$9 = ["icon", "iconSize", "iconAlignment", "background", "contentPosition", "iconPosition", "srLabel", "badge", "children", "onClick", "className"];
const RBCIconButton = _ref => {
  let {
      icon,
      iconSize = 'm',
      iconAlignment,
      background,
      contentPosition,
      iconPosition,
      srLabel,
      badge,
      children,
      onClick,
      className = ''
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  const classes = classNames('rbc-icon-button', {
    'rbc-icon-button-background-primary': background === 'primary',
    'rbc-icon-button-background-alternate': background === 'alternate',
    'rbc-icon-button-background-highlight': background === 'highlight',
    'rbc-icon-button-position-right': iconPosition === undefined && contentPosition === undefined || iconPosition === 'right' || !iconPosition && contentPosition === 'left',
    'rbc-icon-button-position-bottom': iconPosition === 'bottom' || !iconPosition && contentPosition === 'top',
    'rbc-icon-button-position-left': iconPosition === 'left' || !iconPosition && contentPosition === 'right',
    'rbc-icon-button-position-top': iconPosition === 'top' || !iconPosition && contentPosition === 'bottom'
  });
  const iconClasses = classNames({
    'rbc-icon-button-size-s': iconSize === 's' || iconSize <= 31,
    'rbc-icon-button-size-m': iconSize === undefined || iconSize === 'm' || iconSize <= 48,
    'rbc-icon-button-size-l': iconSize === 'l' || iconSize > 48
  });
  const childrenClasses = classNames('rbc-icon-button-content', {
    'rbc-sr-only': iconPosition === 'solo' || !iconPosition && contentPosition === 'hide'
  });
  const getIconAlignmentClass = () => {
    if (iconPosition === 'solo' || contentPosition === 'hide') {
      return '';
    }
    switch (iconPosition || contentPosition) {
      case 'left':
      case 'right':
        if (iconAlignment === 'bottom' || iconAlignment === 'top' || iconAlignment === 'middle') {
          return `rbc-icon-button-alignment-${iconAlignment}`;
        } else {
          return 'rbc-icon-button-alignment-middle';
        }
      case 'top':
      case 'bottom':
        if (iconAlignment === 'left' || iconAlignment === 'right' || iconAlignment === 'center') {
          return `rbc-icon-button-alignment-${iconAlignment}`;
        } else {
          return 'rbc-icon-button-alignment-center';
        }
      default:
        return '';
    }
  };
  return jsx("div", {
    className: `${classes} ${iconClasses} ${className}`,
    children: jsxs("button", Object.assign({
      type: "button",
      className: `rbc-icon-button-container ${getIconAlignmentClass()}`,
      "aria-label": srLabel
    }, props, {
      onClick: onClick,
      children: [jsxs("span", {
        className: `rbc-icon-button-content-icon ${iconClasses}`,
        children: [jsx(RBCIcon, {
          className: `${getIconAlignmentClass()}`,
          token: icon,
          useSprites: false,
          size: iconSize,
          decorative: true
        }), badge && jsx("span", {
          className: "rbc-icon-button-badge",
          children: badge
        })]
      }), jsx("span", {
        className: childrenClasses,
        children: children
      })]
    }))
  });
};

const RBCScrollContainer = ({
  direction,
  children,
  className: _className = ''
}) => {
  const classes = classNames('rbc-scroll-container', {
    'rbc-scroll-container-vertical': direction === undefined || direction === 'vertical',
    'rbc-scroll-container-horizontal': direction === 'horizontal'
  });
  return jsx("div", {
    className: `${classes} ${_className}`,
    children: jsx("div", {
      className: "rbc-scroll-container-content",
      children: children
    })
  });
};

const _excluded$8 = ["parentPanel", "headerText", "initiator", "children", "open", "backSRLabel", "closeSRLabel", "onClose", "className"];
const RBCActionPanel = _ref => {
  let {
      parentPanel,
      headerText,
      initiator,
      children,
      open,
      backSRLabel,
      closeSRLabel,
      onClose,
      className = ''
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  const [breakPoint] = useBreakPointService(Breakpoint.small);
  const {
    back,
    close
  } = getContent(useLocale());
  backSRLabel = back || backSRLabel;
  closeSRLabel = close || closeSRLabel;
  return jsx("div", Object.assign({}, props, {
    className: `rbc-action-panel ${className}`,
    children: jsxs(RBCPanel, {
      open: open,
      role: "dialog",
      onClose: onClose,
      showScrim: true,
      size: "auto",
      position: breakPoint.isAtMost ? 'bottom' : 'inline-occluding',
      initiator: initiator,
      "aria-label": headerText,
      children: [jsxs("h2", {
        className: "rbc-action-panel-header",
        children: [parentPanel ? jsx(RBCIconButton, {
          className: "rbc-action-panel-back-button",
          icon: "chevron-left",
          srLabel: backSRLabel,
          iconSize: "s",
          onClick: onClose
        }) : null, jsx("span", {
          className: "rbc-action-panel-header-label",
          children: headerText
        }), jsx(RBCIconButton, {
          className: "rbc-action-panel-close-button",
          icon: "times",
          srLabel: closeSRLabel,
          iconSize: "s",
          id: "panel-close",
          onClick: onClose
        })]
      }), jsx(RBCScrollContainer, {
        direction: "vertical",
        className: "rbc-action-panel-body",
        children: children
      })]
    })
  }));
};

const MenuGrid = ({
  label,
  children,
  headingLevel
}) => {
  const distributeEvenly = false;
  const direction = 'horizontal';
  return jsxs("div", {
    className: "rbc-menu-grid",
    role: "group",
    children: [jsx("div", {
      className: "rbc-menu-grid-heading",
      role: "heading",
      "aria-level": Number(headingLevel) || 1,
      children: label
    }), jsx(Stack, {
      role: "list",
      distributeEvenly: distributeEvenly,
      direction: direction,
      children: children,
      dividerCap: undefined,
      dividerBetween: undefined
    })]
  });
};

const _excluded$7 = ["src", "tabId", "label", "srLabel", "wrapped", "truncate", "tabWidth", "selected", "type", "icon", "density", "children"];
const RBCNavTab = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      src,
      tabId,
      label,
      srLabel,
      wrapped = false,
      truncate = 'none',
      tabWidth = 'auto',
      selected = false,
      type = 'link',
      icon,
      density = 'default',
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  const locale = useLocale();
  const selectedLabel = locale.includes('fr') ? 'page actuelle' : 'Current page';
  const Link = useLinkComponent();
  const style = {};
  if (typeof tabWidth === 'number') {
    style.width = `${tabWidth}px`;
    style.minWidth = `${tabWidth}px`;
    if (truncate === 'none') {
      style.whiteSpace = 'normal';
    }
  }
  const listItemClasses = classNames('rbc-nav-tab', {
    'rbc-nav-tab-selected': selected,
    'rbc-nav-tab-wrapped': wrapped,
    'rbc-nav-tab-truncate': truncate === 'end',
    'rbc-nav-tab-wrap': typeof tabWidth === 'number'
  });
  const linkClasses = classNames('rbc-nav-tab-label', {
    'rbc-nav-tab-with-icon': icon
  });
  return jsx("li", {
    className: listItemClasses,
    ref: ref,
    children: jsxs(Link, Object.assign({}, props, {
      className: linkClasses,
      id: tabId,
      "aria-label": srLabel,
      url: src,
      style: style,
      elementType: type,
      children: [icon && jsx(RBCIcon, {
        decorative: true,
        token: icon,
        size: getTabIconDensity(density, window.innerWidth)
      }), jsx("span", {
        className: "rbc-nav-tab-label-text",
        children: label
      }), children, selected && jsx("span", {
        className: "rbc-sr-only",
        children: selectedLabel
      })]
    }))
  });
});
RBCNavTab.displayName = 'RBCNavTab';

function useOverflow(ref) {
  const [hasXOverflow, setRefXOverflowing] = useState(false);
  const [hasYOverflow, setRefYOverflowing] = useState(false);
  const [isAtScrollXStart, setRefXScrollBegin] = useState(true);
  const [isAtScrollXEnd, setRefXScrollEnd] = useState(false);
  const [isAtScrollYStart, setRefYScrollBegin] = useState(true);
  const [isAtScrollYEnd, setRefYScrollEnd] = useState(false);
  const size = useWindowSize();
  useEffect(() => {
    if (!ref.current) {
      return;
    }
    const el = ref.current;
    const isXOverflowing = el.scrollWidth > el.clientWidth;
    const isYOverflowing = el.scrollHeight > el.clientHeight;
    if (hasXOverflow !== isXOverflowing) {
      setRefXOverflowing(isXOverflowing);
    }
    if (hasYOverflow !== isYOverflowing) {
      setRefYOverflowing(isYOverflowing);
    }
    const handleScroll = () => {
      // Handle X Overflow
      const offsetRight = el.scrollWidth - el.clientWidth;
      if (el.scrollLeft >= offsetRight && isAtScrollXEnd === false) {
        setRefXScrollEnd(true);
      } else {
        setRefXScrollEnd(false);
      }
      if (el.scrollLeft === 0) {
        setRefXScrollBegin(true);
      } else {
        setRefXScrollBegin(false);
      }
      // Handle Y Overflow
      const offsetBottom = el.scrollHeight - el.clientHeight;
      if (el.scrollTop >= offsetBottom && isAtScrollYEnd === false) {
        setRefYScrollEnd(true);
      } else {
        setRefYScrollEnd(false);
      }
      if (el.scrollTop === 0) {
        setRefYScrollBegin(true);
      } else {
        setRefYScrollBegin(false);
      }
    };
    el.addEventListener('scroll', handleScroll);
    return () => el.removeEventListener('scroll', handleScroll);
  }, [ref, size.width]);
  return {
    hasXOverflow,
    hasYOverflow,
    isAtScrollXStart,
    isAtScrollXEnd,
    isAtScrollYStart,
    isAtScrollYEnd
  };
}

const _excluded$6 = ["density", "distributeEvenly", "containerWidth", "selected", "children", "className"];
const TAB_SET_CONTROL_WIDTH$1 = 28;
const RBCNavTabs = _ref => {
  let {
      density = 'default',
      distributeEvenly = false,
      containerWidth = 'fill',
      selected,
      children,
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  const tabsClasses = classNames('rbc-nav-tabs', 'rbc-nav-tabs-header', 'rbc-nav-tabs-background', className, {
    'rbc-tabs-default': density === 'default',
    'rbc-tabs-compact': density === 'compact',
    'rbc-tabs-comfortable': density === 'comfortable',
    'rbc-tabs-distribute-evenly': distributeEvenly,
    'rbc-tabs-container-fill': containerWidth === 'fill',
    'rbc-tabs-container-fit': containerWidth === 'fit'
  });
  const [selectedTab, setSelectedTab] = useState(null);
  // tslint:disable-next-line:no-non-null-assertion
  const TabsListRef = useRef(null);
  const {
    isAtScrollXStart,
    isAtScrollXEnd,
    hasXOverflow
  } = useOverflow(TabsListRef);
  const showPreviousSet = () => {
    const {
      left
    } = TabsListRef.current.getBoundingClientRect();
    const previousTab = TabItemsRefs().find(tab => tab.getBoundingClientRect().right - left > 0);
    scrollToElementRight(previousTab);
  };
  const showNextSet = () => {
    const {
      left,
      width
    } = TabsListRef.current.getBoundingClientRect();
    const nextTab = TabItemsRefs().find(tab => tab.getBoundingClientRect().right - left > width);
    scrollToElementLeft(nextTab);
  };
  const TabComps = [];
  React.Children.map(children, child => {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      const ref = useRef();
      const tab = /*#__PURE__*/React.cloneElement(child, {
        ref,
        density
      });
      TabComps.push(tab);
    }
  });
  useEffect(() => {
    const currTab = TabComps.find(tab => tab.props.tabId === selected || tab.props.selected);
    setSelectedTab(currTab);
  }, [selected]);
  useEffect(() => {
    if (selectedTab && selectedTab.ref) {
      scrollToElementLeft(selectedTab.ref.current);
    }
  }, [selectedTab]);
  const TabItemsRefs = () => TabComps.map(tab => tab.ref.current);
  const scrollToElementRight = element => {
    if (!element) return;
    const elementRect = element.getBoundingClientRect();
    const tabsListRect = TabsListRef.current.getBoundingClientRect();
    const adjustedRight = elementRect.right - tabsListRect.left;
    const scrollLeft = Math.round(TabsListRef.current.scrollLeft + adjustedRight + TAB_SET_CONTROL_WIDTH$1 - tabsListRect.width);
    TabsListRef.current.scrollLeft = scrollLeft;
  };
  const scrollToElementLeft = element => {
    if (!element) return;
    const elementRect = element.getBoundingClientRect();
    const tabsListRect = TabsListRef.current.getBoundingClientRect();
    const scrollLeft = Math.round(elementRect.left - tabsListRect.left + TabsListRef.current.scrollLeft - TAB_SET_CONTROL_WIDTH$1);
    TabsListRef.current.scrollLeft = scrollLeft;
  };
  return jsxs("div", Object.assign({
    className: tabsClasses
  }, props, {
    children: [hasXOverflow && !isAtScrollXStart && jsx("button", {
      className: "rbc-nav-tabs-previous",
      tabIndex: -1,
      onClick: showPreviousSet,
      children: jsx(RBCIcon, {
        size: getTabsToggleIconDensity(density),
        token: 'angle-left',
        decorative: true
      })
    }), jsx("ul", {
      className: "rbc-nav-tabs-list rbc-tabs-smooth-scroll",
      ref: TabsListRef,
      children: TabComps
    }), hasXOverflow && !isAtScrollXEnd && jsx("button", {
      className: "rbc-nav-tabs-next",
      tabIndex: -1,
      onClick: showNextSet,
      children: jsx(RBCIcon, {
        size: getTabsToggleIconDensity(density),
        token: 'angle-right',
        decorative: true
      })
    })]
  }));
};
RBCNavTabs.displayName = 'RBCNavTabs';

const NavProduct = ({
  showImage: _showImage = false,
  image,
  greeting,
  destinations,
  selectedDestination,
  utility1,
  utility2,
  srLabel: _srLabel = 'product'
}) => {
  const [breakPoint] = useBreakPointService(Breakpoint.small);
  const iconPosition = breakPoint.isAtMost ? 'solo' : 'right';
  return jsxs("div", {
    className: `rbc-nav-product ${_showImage ? '' : 'rbc-nav-product-no-image'}`,
    children: [_showImage && jsxs("div", {
      className: "rbc-nav-product-image",
      children: [image, jsx("p", {
        className: "rbc-nav-product-greeting",
        children: greeting
      })]
    }), jsxs("nav", {
      "aria-label": _srLabel,
      children: [jsx("div", {
        className: "rbc-nav-product-left",
        children: jsx(RBCNavTabs, {
          className: "rbc-nav-tabs--opposite",
          density: "compact",
          containerWidth: "fill",
          distributeEvenly: false,
          children: destinations.map(destination => jsx(RBCNavTab, {
            label: destination.label,
            src: destination.src,
            tabId: destination.destinationId,
            type: destination.type,
            selected: destination.destinationId === selectedDestination || destination.src === selectedDestination
          }))
        })
      }), jsxs("div", {
        className: "rbc-nav-product-right",
        role: "list",
        children: [utility1 && /*#__PURE__*/React.cloneElement(utility1, {
          iconSize: 20,
          iconPosition: iconPosition
        }), utility2 && /*#__PURE__*/React.cloneElement(utility2, {
          iconSize: 20,
          iconPosition: iconPosition
        })]
      })]
    })]
  });
};
NavProduct.displayName = 'NavProduct';

const RBCNav = ({
  children
}) => {
  return jsx("nav", {
    children: children
  });
};

const RBCNotificationBadge = ({
  kind,
  srLabel: _srLabel = '',
  value,
  className: _className = ''
}) => {
  const classes = classNames('rbc-notification-badge', _className, {
    'rbc-notification-badge-danger': kind === undefined || kind === 'danger',
    'rbc-notification-badge-info': kind === 'info',
    'rbc-notification-badge-warning': kind === 'warning',
    'rbc-notification-badge-success': kind === 'success',
    'rbc-notification-badge-neutral': kind === 'neutral'
  });
  return jsx("div", {
    className: classes,
    "aria-label": _srLabel,
    children: jsx("span", {
      children: value
    })
  });
};

const ProfileContent = ({
  description,
  prefixIcon,
  suffixIcon,
  user
}) => {
  return jsxs(Fragment, {
    children: [prefixIcon && jsx("span", {
      className: "rbc-profile-box-icon-prefix",
      children: jsx(RBCIcon, {
        token: prefixIcon,
        size: "s",
        decorative: true
      })
    }), jsxs("div", {
      className: "rbc-profile-box-content",
      children: [jsx("span", {
        className: "rbc-profile-box__text",
        children: user.fullName
      }), description ? jsx("span", {
        className: "rbc-profile-box__description",
        children: description
      }) : null]
    }), suffixIcon && jsx("span", {
      className: "rbc-profile-box-icon-suffix",
      children: jsx(RBCIcon, {
        token: suffixIcon,
        size: "s",
        decorative: true
      })
    })]
  });
};
const RBCProfileBox = ({
  description,
  itemId,
  prefixIcon,
  srLabel,
  suffixIcon,
  target,
  user: _user = {
    fullName: ''
  }
}) => {
  const linkClasses = classNames('rbc-profile-box-container', {
    'rbc-menu-item--icon-prefix': prefixIcon,
    'rbc-menu-item--icon-suffix': suffixIcon
  });
  const content = jsx(ProfileContent, {
    description: description,
    prefixIcon: prefixIcon,
    suffixIcon: suffixIcon,
    user: _user
  });
  return jsx("div", {
    className: "rbc-profile-box",
    children: target === 'child' ? jsx("button", {
      className: "rbc-profile-box-container",
      type: "button",
      id: itemId,
      "aria-label": srLabel,
      children: content
    }) : jsx("div", {
      className: linkClasses,
      id: itemId,
      children: content
    })
  });
};

const RBCSuiteNavigation = ({
  currentUser,
  homeLink,
  logosrc: _logosrc = '/assets/logo-feature/media/Logo_NR_Light.svg',
  notifications,
  profileContent,
  profileLabel: _profileLabel = 'Profile & Notifications',
  showSignOutNav: _showSignOutNav = false,
  showSignInNav: _showSignInNav = false,
  onClickSignIn,
  onClickSignOut,
  srLabels: _srLabels = {},
  switcherText,
  switcherContent
}) => {
  const [openedSwitcherPanel, setOpenedSwitcherPanel] = useState(false);
  const [openedProfilePanel, setOpenedProfilePanel] = useState(false);
  const [breakPoint] = useBreakPointService(Breakpoint.small);
  const signInLabel = 'Sign In';
  const signOutLabel = 'Sign Out';
  useLayoutEffect(() => {}, [breakPoint]);
  return jsx(Fragment, {
    children: jsxs("div", {
      className: "rbc-nav-suite",
      children: [jsxs("nav", {
        "aria-label": _srLabels['nav-landmark'],
        children: [jsx("div", {
          className: "rbc-nav-suite-left",
          children: jsx("a", {
            href: homeLink,
            id: "suite-nav-home-link",
            className: "rbc-nav-suite__logo-container",
            "aria-label": _srLabels['home-link'],
            children: jsx("img", {
              className: "rbc-nav-suite__logo",
              src: _logosrc,
              alt: "",
              role: "presentation"
            })
          })
        }), jsxs(Stack, {
          className: "rbc-nav-suite-right",
          direction: "horizontal",
          dividerBetween: switcherText && (currentUser || _showSignOutNav || _showSignInNav) ? 'sm' : undefined,
          children: [switcherText && jsx(RBCIconButton, {
            className: "rbc-nav-suite-switcher-button",
            iconPosition: "right",
            icon: "waffle",
            iconSize: breakPoint.isAtMost ? 's' : 24,
            id: "switcher-button",
            onClick: () => setOpenedSwitcherPanel(true),
            srLabel: _srLabels['switcher-button'],
            children: switcherText
          }), jsxs(Stack, {
            direction: "horizontal",
            children: [currentUser && jsx(RBCIconButton, {
              className: "rbc-nav-suite-profile-button",
              iconPosition: "solo",
              icon: "profile",
              iconSize: breakPoint.isAtMost ? 's' : 24,
              id: "profile-button",
              onClick: () => setOpenedProfilePanel(true),
              srLabel: notifications ? `${_srLabels['profile-button']}, ${_srLabels['profile-button-notification']}` : `${_srLabels['profile-button']}`,
              badge: notifications ? jsx(RBCNotificationBadge, {
                kind: "danger",
                srLabel: `${_srLabels['profile-button-notification']}`,
                value: notifications
              }) : ''
            }), _showSignOutNav && !breakPoint.isAtMost && jsx(RBCIconButton, {
              className: "rbc-nav-suite-signout-button",
              iconPosition: "solo",
              icon: "sign-out",
              iconSize: breakPoint.isAtMost ? 's' : 24,
              id: "signout-button",
              onClick: onClickSignOut,
              srLabel: `${_srLabels['signout-button']}`
            }), !currentUser && _showSignInNav && jsx(RBCIconButton, {
              className: "rbc-nav-suite-signin-button",
              iconPosition: breakPoint.isAtMost ? 'solo' : 'left',
              icon: "sign-in",
              iconSize: breakPoint.isAtMost ? 's' : 24,
              id: "signin-button",
              onClick: onClickSignIn,
              srLabel: `${_srLabels['signin-button']}`,
              children: signInLabel
            })]
          })]
        })]
      }), jsx(RBCActionPanel, {
        id: "switcher-panel",
        initiator: "switcher-button",
        headerText: switcherText,
        open: openedSwitcherPanel,
        onClose: () => setOpenedSwitcherPanel(false),
        children: jsx(Stack, {
          className: "rbc-nav-suite-switcher-stack",
          direction: "vertical",
          children: switcherContent
        })
      }), jsx(RBCActionPanel, {
        id: "profile-panel",
        initiator: "profile-button",
        headerText: _profileLabel,
        open: openedProfilePanel,
        onClose: () => setOpenedProfilePanel(false),
        children: jsxs(Stack, {
          className: "rbc-nav-suite-switcher-stack",
          direction: "vertical",
          children: [jsx(BoxContainer, {
            background: "alternate",
            outline: "none",
            className: "rbc-nav-suite-profile-box-container",
            children: jsx(RBCProfileBox, {
              itemId: "profile-1",
              prefixIcon: "profile",
              user: currentUser
            })
          }), profileContent, jsx(BoxContainer, {
            className: "rbc-nav-suite-sign-out-button-container",
            outline: "none",
            background: "alternate",
            children: jsx(CTA, {
              priority: "accent",
              size: "small",
              "aria-label": `${signOutLabel}`,
              onClick: () => {
                setOpenedProfilePanel(false);
                onClickSignOut == null ? void 0 : onClickSignOut();
              },
              children: signOutLabel
            })
          })]
        })
      })]
    })
  });
};

const Page = ({
  dockSectionNavigation,
  kind: _kind = 'fixed',
  mainContent,
  header,
  sectionNavigation,
  footer
}) => {
  const classes = classNames(['rbc-nav-page']);
  let sectionNav;
  if (sectionNavigation) {
    sectionNav = jsx(Fragment, {
      children: jsx(FlexItem, {
        children: sectionNavigation
      })
    });
  } else {
    sectionNav = null;
  }
  let mainSection;
  if (dockSectionNavigation) {
    mainSection = jsx(Fragment, {
      children: jsxs(FlexLayout, {
        direction: {
          xs: 'vertical',
          xl: 'horizontal'
        },
        verticalAlignment: 'fill-container',
        horizontalAlignment: 'fill-container',
        children: [sectionNav, jsx(FlexItem, {
          growFactor: 1,
          children: jsxs(FlexLayout, {
            direction: 'vertical',
            children: [jsx(FlexItem, {
              growFactor: 1,
              children: mainContent
            }), jsx(FlexItem, {
              children: footer
            })]
          })
        })]
      })
    });
  } else {
    mainSection = jsxs(Fragment, {
      children: [jsx(LayoutContainer, {
        kind: _kind,
        hasMargins: true,
        children: jsxs(FlexLayout, {
          direction: {
            xs: 'vertical',
            xl: 'horizontal'
          },
          verticalAlignment: 'fill-container',
          horizontalAlignment: 'fill-container',
          children: [sectionNav, jsx(FlexItem, {
            growFactor: 1,
            children: mainContent
          })]
        })
      }), jsx(Fragment, {
        children: footer
      })]
    });
  }
  return jsxs("div", {
    className: classes,
    children: [jsx(Fragment, {
      children: header
    }), jsx(Fragment, {
      children: mainSection
    })]
  });
};
/**
 * @deprecated Since 3.0.0-alpha.3. Use Page instead of PageComponent
 */
const PageComponent = Page;

const RBCGlobalProvider = ({
  linkComponent,
  i18nConfig,
  children
}) => {
  return jsx(I18nProvider, {
    i18nConfig: i18nConfig,
    children: jsx(LinkComponentProvider, {
      linkComponent: linkComponent,
      children: children
    })
  });
};

const _excluded$5 = ["isValid", "options", "placeholder", "darkBg", "className", "disabled"];
const Select = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      isValid,
      options,
      placeholder = '',
      darkBg,
      className,
      disabled
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  const parentClass = classNames('rbc-select', {
    'rbc-select-dark': darkBg === true,
    'rbc-select-disabled': disabled === true
  });
  const wrapperClass = classNames('rbc-select__wrapper', {
    'rbc-select__wrapper--error': isValid === false
  });
  const selectClass = classNames('rbc-select-input', className);
  return jsx("div", {
    className: parentClass,
    children: jsx("div", {
      className: wrapperClass,
      children: jsxs("select", Object.assign({
        ref: ref,
        className: selectClass,
        disabled: disabled
      }, props, {
        children: [placeholder && jsx("option", {
          value: "",
          hidden: true,
          selected: true,
          children: placeholder
        }), options && options.map(option => jsx("option", {
          value: option.value,
          disabled: option.disabled,
          children: option.label
        }))]
      }))
    })
  });
});

const Tab = /*#__PURE__*/React.forwardRef(({
  tabId,
  label,
  wrapped: _wrapped = false,
  truncate: _truncate = 'none',
  srLabel,
  tabWidth: _tabWidth = 'auto',
  selected: _selected = false,
  setSelected,
  icon,
  density: _density = 'default',
  children
}, ref) => {
  const divClasses = classNames('rbc-tab', {
    'rbc-tab-selected': _selected,
    'rbc-tab-wrapped': _wrapped,
    'rbc-tab-truncate': _truncate === 'end',
    'rbc-tab-wrap': typeof _tabWidth === 'number'
  });
  const tabLabelClasses = classNames('rbc-tab-label', {
    'rbc-tab-with-icon': icon
  });
  const panel = `${tabId}-panel`;
  const handleKeyPress = e => {
    const enterOrSpace = e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.which === 13 || e.which === 32;
    if (enterOrSpace) {
      e.preventDefault();
      setSelected == null ? void 0 : setSelected();
    }
  };
  const getStyle = () => {
    const style = {};
    if (typeof _tabWidth === 'number') {
      style.width = `${_tabWidth}px`;
      style.minWidth = `${_tabWidth}px`;
      if (_truncate === 'none') {
        style.whiteSpace = 'normal';
      }
    }
    return style;
  };
  return jsx("div", {
    className: divClasses,
    role: "tab",
    onClick: setSelected,
    onKeyPress: handleKeyPress,
    "aria-label": srLabel,
    "aria-selected": _selected,
    "aria-controls": panel,
    tabIndex: _selected ? 0 : -1,
    id: tabId,
    ref: ref,
    children: jsxs("div", {
      className: tabLabelClasses,
      style: getStyle(),
      children: [icon && jsx(RBCIcon, {
        decorative: true,
        token: icon,
        size: getTabIconDensity(_density, window.innerWidth)
      }), jsx("span", {
        className: "rbc-tab-label-text",
        children: label
      }), children]
    })
  });
});

const TabPanel = ({
  tabId,
  selected: _selected = false,
  children
}) => {
  const classes = classNames('rbc-tab-panel', {
    'rbc-tab-panel-selected': _selected
  });
  const id = `${tabId}-panel`;
  return jsx("div", {
    className: classes,
    hidden: !_selected,
    children: jsx("div", {
      role: "tabpanel",
      className: "rbc-tab-panel-content",
      id: id,
      "aria-labelledby": tabId,
      tabIndex: 0,
      children: children
    })
  });
};

const TAB_SET_CONTROL_WIDTH = 28;
const Tabs = ({
  selected,
  selectedChange,
  density: _density = 'default',
  distributeEvenly: _distributeEvenly = false,
  srLabel,
  containerWidth: _containerWidth = 'fill',
  children
}) => {
  const [selectedTab, setSelectedTab] = useState(null);
  const classes = classNames('rbc-tabs', 'rbc-tabs-background', {
    'rbc-tabs-default': _density === 'default',
    'rbc-tabs-compact': _density === 'compact',
    'rbc-tabs-comfortable': _density === 'comfortable',
    'rbc-tabs-distribute-evenly': _distributeEvenly,
    'rbc-tabs-container-fill': _containerWidth === 'fill',
    'rbc-tabs-container-fit': _containerWidth === 'fit'
  });
  // tslint:disable-next-line:no-non-null-assertion
  const TabsListRef = useRef(null);
  const {
    isAtScrollXStart,
    isAtScrollXEnd,
    hasXOverflow
  } = useOverflow(TabsListRef);
  const showPreviousSet = () => {
    const {
      left
    } = TabsListRef.current.getBoundingClientRect();
    const previousTab = TabItemsRefs().find(tab => tab.getBoundingClientRect().right - left > 0);
    scrollToElementRight(previousTab);
  };
  const showNextSet = () => {
    const {
      left,
      width
    } = TabsListRef.current.getBoundingClientRect();
    const nextTab = TabItemsRefs().find(tab => tab.getBoundingClientRect().right - left > width);
    scrollToElementLeft(nextTab);
  };
  const TabComps = [];
  const TabPanelComps = [];
  React.Children.map(children, child => {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      if (child.type === Tab) {
        const isSelected = selectedTab && child.props.tabId === selectedTab.props.tabId;
        const ref = useRef();
        const tab = /*#__PURE__*/React.cloneElement(child, {
          ref,
          density: _density,
          selected: isSelected,
          setSelected: () => {
            if (!selectedTab || child.props.tabId !== selectedTab.props.tabId) {
              setSelectedTab(tab);
            }
          }
        });
        TabComps.push(tab);
      } else if (child.type === TabPanel) {
        const tabPanel = /*#__PURE__*/React.cloneElement(child, {
          selected: selectedTab && selectedTab.props.tabId === child.props.tabId
        });
        TabPanelComps.push(tabPanel);
      }
    }
  });
  useEffect(() => {
    const currTab = TabComps.find(tab => tab.props.tabId === selected) || TabComps[0];
    setSelectedTab(currTab);
  }, [selected]);
  useEffect(() => {
    if (selectedTab && selectedTab.ref) {
      scrollToElementLeft(selectedTab.ref.current);
      selectedChange == null ? void 0 : selectedChange(selectedTab.props.tabId);
    }
  }, [selectedTab]);
  const TabItemsRefs = () => TabComps.map(tab => tab.ref.current);
  const focusedTab = tabs => tabs.find(item => item.contains(document.activeElement));
  const focusedTabIndex = tabs => tabs.findIndex(item => item.contains(document.activeElement));
  const handleKeyDown = event => {
    let tab;
    if (event.target !== TabsListRef && !TabsListRef.current.contains(event.target)) {
      return;
    }
    const tabs = TabItemsRefs();
    switch (event.key) {
      case 'ArrowLeft':
        if (focusedTab(tabs) === tabs[0]) {
          scrollToElementRight(tabs[tabs.length - 1]);
          tabs[tabs.length - 1].focus();
          break;
        }
        tab = tabs.find((t, index) => index === focusedTabIndex(tabs) - 1);
        if (tab) {
          scrollToElement(tab);
          tab.focus();
        }
        break;
      case 'ArrowRight':
        if (focusedTab(tabs) === tabs[tabs.length - 1]) {
          scrollToElementLeft(tabs[0]);
          tabs[0].focus();
          break;
        }
        tab = tabs.find((t, index) => index === focusedTabIndex(tabs) + 1);
        if (tab) {
          scrollToElement(tab);
          tab.focus();
        }
        break;
      case 'Home':
        tabs[0].focus();
        scrollToElementLeft(tabs[0]);
        break;
      case 'End':
        tabs[tabs.length - 1].focus();
        scrollToElementRight(tabs[tabs.length - 1]);
        break;
      default:
        return;
    }
    event.preventDefault();
  };
  const scrollToElementRight = element => {
    const elementRect = element.getBoundingClientRect();
    const tabsListRect = TabsListRef.current.getBoundingClientRect();
    const adjustedRight = elementRect.right - tabsListRect.left;
    const scrollLeft = Math.round(TabsListRef.current.scrollLeft + adjustedRight + TAB_SET_CONTROL_WIDTH - tabsListRect.width);
    TabsListRef.current.scrollLeft = scrollLeft;
  };
  const scrollToElementLeft = element => {
    const elementRect = element.getBoundingClientRect();
    const tabsListRect = TabsListRef.current.getBoundingClientRect();
    const scrollLeft = Math.round(elementRect.left - tabsListRect.left + TabsListRef.current.scrollLeft - TAB_SET_CONTROL_WIDTH);
    TabsListRef.current.scrollLeft = scrollLeft;
  };
  const scrollToElement = element => {
    const elementRect = element.getBoundingClientRect();
    const tabsListRect = TabsListRef.current.getBoundingClientRect();
    const overflowsLeft = elementRect.left - tabsListRect.left < 0;
    const overflowsRight = elementRect.right - tabsListRect.left > tabsListRect.width;
    if (overflowsLeft) {
      scrollToElementLeft(element);
    } else if (overflowsRight) {
      scrollToElementRight(element);
    }
  };
  return jsxs("div", {
    className: classes,
    onKeyDown: handleKeyDown,
    children: [jsxs("div", {
      className: "rbc-tabs-header",
      children: [hasXOverflow && !isAtScrollXStart && jsx("button", {
        "aria-label": "previous tabs",
        className: "rbc-tabs-previous",
        onClick: showPreviousSet,
        children: jsx(RBCIcon, {
          size: getTabsToggleIconDensity(_density),
          token: "angle-left",
          decorative: true
        })
      }), jsx("div", {
        className: "rbc-tabs-list rbc-tabs-smooth-scroll",
        role: "tablist",
        "aria-label": srLabel,
        ref: TabsListRef,
        children: TabComps
      }), hasXOverflow && !isAtScrollXEnd && jsx("button", {
        "aria-label": "next tabs",
        className: "rbc-tabs-next",
        onClick: showNextSet,
        children: jsx(RBCIcon, {
          size: getTabsToggleIconDensity(_density),
          token: "angle-right",
          decorative: true
        })
      })]
    }), TabPanelComps]
  });
};

// Temporary solution
// TODO: Aim to adopt Angular icon/sprite pattern
const help = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiIgZml0PSIiIGhlaWdodD0iMTAwJSIgd2lkdGg9IjEwMCUiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIGZvY3VzYWJsZT0iZmFsc2UiIGZpbGw9IiMwMDZhYzMiPjxwYXRoIGNsYXNzPSJjbmMxIiBkPSJNOCAwYTggOCAwIDEgMCAwIDE2QTggOCAwIDAgMCA4IDB6bTAgMTVjLTMuODYgMC03LTMuMTQtNy03czMuMTQtNyA3LTcgNyAzLjE0IDcgNy0zLjE0IDctNyA3eiIvPjxwYXRoIGNsYXNzPSJjbmMxIiBkPSJNOC4yMjMgMy43MDJjLTEuMTMxIDAtMi4wNzkuNjkyLTIuMzA1IDEuNjgyYS41LjUgMCAxIDAgLjk3NS4yMjJjLjEyMi0uNTMyLjY2OS0uOTA0IDEuMzMtLjkwNC43NjQgMCAxLjE3Ni42ODggMS4xNzYgMS4zMzUgMCAuNjk5LS42NjcgMS4zMzYtMS4zOTkgMS4zMzZhLjUuNSAwIDAgMC0uNS41djEuNDA2YS41LjUgMCAxIDAgMSAwdi0uOTYyYzEuMDU3LS4yMzggMS45LTEuMjAxIDEuOS0yLjI4IDAtMS4zMS0uOTU3LTIuMzM1LTIuMTc3LTIuMzM1eiIvPjxjaXJjbGUgY2xhc3M9ImNuYzEiIGN4PSI4IiBjeT0iMTEuODEiIHI9Ii43NSIvPjwvc3ZnPg==';
const help_md = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgZml0PSIiIGhlaWdodD0iMTAwJSIgd2lkdGg9IjEwMCUiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIGZvY3VzYWJsZT0iZmFsc2UiIGZpbGw9IiMwMDZhYzMiPjxwYXRoIGNsYXNzPSJjbmMxIiBkPSJNMTYgMEM3LjE2MyAwIDAgNy4xNjMgMCAxNnM3LjE2MyAxNiAxNiAxNiAxNi03LjE2MyAxNi0xNlMyNC44MzcgMCAxNiAwem0wIDMwLjZDNy45NSAzMC42IDEuNCAyNC4wNSAxLjQgMTZTNy45NSAxLjQgMTYgMS40IDMwLjYgNy45NSAzMC42IDE2IDI0LjA1IDMwLjYgMTYgMzAuNnoiLz48cGF0aCBjbGFzcz0iY25jMSIgZD0iTTE2LjQ0NyA3Ljk1OGMtMi4xMjIgMC0zLjg5OCAxLjI4OC00LjMxOCAzLjEzMWEuNy43IDAgMCAwIDEuMzY2LjMxYy4yNzQtMS4yMDEgMS40ODctMi4wNCAyLjk1Mi0yLjA0IDEuNTExIDAgMi42NTIgMS4yNzYgMi42NTIgMi45NyAwIDEuNTU1LTEuNDc3IDIuOTctMy4wOTkgMi45N2EuNy43IDAgMCAwLS43LjcwMXYyLjMwNmEuNy43IDAgMSAwIDEuNCAwdi0xLjY2NGMyLjA5Mi0uMzQ5IDMuNzk5LTIuMjE1IDMuNzk5LTQuMzEzIDAtMi40NTEtMS43OC00LjM3MS00LjA1Mi00LjM3MXoiLz48Y2lyY2xlIGNsYXNzPSJjbmMxIiBjeD0iMTYiIGN5PSIyMyIgcj0iMSIvPjwvc3ZnPg==';
const help_s = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiIgZml0PSIiIGhlaWdodD0iMTAwJSIgd2lkdGg9IjEwMCUiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIGZvY3VzYWJsZT0iZmFsc2UiIGZpbGw9IiMwMDZhYzMiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOCAwQzMuNiAwIDAgMy42IDAgOHMzLjYgOCA4IDggOC0zLjYgOC04LTMuNi04LTgtOHptMCA5LjhjLS4zIDAtLjUtLjItLjUtLjVWNy45YzAtLjMuMi0uNS41LS41LjcgMCAxLjQtLjYgMS40LTEuMyAwLS42LS40LTEuMy0xLjItMS4zLS42LS4xLTEuMi4zLTEuMy44LS4xLjMtLjMuNC0uNi40LS4zLS4xLS40LS4zLS40LS42LjItMSAxLjItMS43IDIuMy0xLjcgMS4yIDAgMi4yIDEgMi4yIDIuMyAwIDEuMS0uOCAyLTEuOSAyLjN2MWMwIC4zLS4yLjUtLjUuNXptMCAyLjhBLjguOCAwIDEgMCA4IDExYS44LjggMCAwIDAgMCAxLjZ6Ii8+PC9zdmc+';
const help_s_md = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgZml0PSIiIGhlaWdodD0iMTAwJSIgd2lkdGg9IjEwMCUiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIGZvY3VzYWJsZT0iZmFsc2UiIGZpbGw9IiMwMDZhYzMiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMzIgMTZjMCA4LjgzNy03LjE2MyAxNi0xNiAxNlMwIDI0LjgzNyAwIDE2IDcuMTYzIDAgMTYgMHMxNiA3LjE2MyAxNiAxNnpNMTYuNDQ3IDcuOTU4Yy0yLjEyMiAwLTMuODk4IDEuMjg4LTQuMzE4IDMuMTMxYS43LjcgMCAxIDAgMS4zNjYuMzFjLjI3NC0xLjIwMSAxLjQ4Ny0yLjA0IDIuOTUyLTIuMDQgMS41MTEgMCAyLjY1MiAxLjI3NiAyLjY1MiAyLjk3IDAgMS41NTUtMS40NzcgMi45Ny0zLjA5OSAyLjk3YS42OTkuNjk5IDAgMCAwLS43LjcwMXYyLjMwNmEuNy43IDAgMCAwIDEuNCAwdi0xLjY2NGMyLjA5Mi0uMzQ5IDMuNzk5LTIuMjE1IDMuNzk5LTQuMzEzIDAtMi40NTEtMS43OC00LjM3MS00LjA1Mi00LjM3MXpNMTcgMjNhMSAxIDAgMSAxLTIgMCAxIDEgMCAwIDEgMiAweiIvPjwvc3ZnPg==';
const info = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiIgZml0PSIiIGhlaWdodD0iMTAwJSIgd2lkdGg9IjEwMCUiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIGZvY3VzYWJsZT0iZmFsc2UiIGZpbGw9IiMwMDZhYzMiPjxwYXRoIGNsYXNzPSJjcWMxIiBkPSJNNyA0aDJ2Mkg3em0yIDdWN0g2djFoMXYzSDZ2MWg0di0xeiIvPjxwYXRoIGNsYXNzPSJjcWMxIiBkPSJNOCAxYzMuOSAwIDcgMy4xIDcgN3MtMy4xIDctNyA3LTctMy4xLTctNyAzLjEtNyA3LTdtMC0xQzMuNiAwIDAgMy42IDAgOHMzLjYgOCA4IDggOC0zLjYgOC04LTMuNi04LTgtOHoiLz48L3N2Zz4=';
const info_md = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgZml0PSIiIGhlaWdodD0iMTAwJSIgd2lkdGg9IjEwMCUiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIGZvY3VzYWJsZT0iZmFsc2UiIGZpbGw9IiMwMDZhYzMiPjxwYXRoIGNsYXNzPSJjcWMxIiBkPSJNMTYgMEM3LjE2MyAwIDAgNy4xNjMgMCAxNnM3LjE2MyAxNiAxNiAxNiAxNi03LjE2MyAxNi0xNlMyNC44MzcgMCAxNiAwem0wIDMwLjZDNy45NSAzMC42IDEuNCAyNC4wNSAxLjQgMTZTNy45NSAxLjQgMTYgMS40IDMwLjYgNy45NSAzMC42IDE2IDI0LjA1IDMwLjYgMTYgMzAuNnoiLz48cGF0aCBjbGFzcz0iY3FjMSIgZD0iTTE4IDIxLjA1aC0xLjN2LTYuNTZhLjcuNyAwIDAgMC0uNy0uN2gtMmEuNy43IDAgMSAwIDAgMS40aDEuM3Y1Ljg2SDE0YS43LjcgMCAxIDAgMCAxLjRoNGEuNy43IDAgMSAwIDAtMS40eiIvPjxjaXJjbGUgY2xhc3M9ImNxYzEiIGN4PSIxNiIgY3k9IjEwLjc1IiByPSIxLjI1Ii8+PC9zdmc+';
const info_s = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiIgZml0PSIiIGhlaWdodD0iMTAwJSIgd2lkdGg9IjEwMCUiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIGZvY3VzYWJsZT0iZmFsc2UiIGZpbGw9IiMwMDZhYzMiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOCAxNmMtNC40IDAtOC0zLjYtOC04czMuNi04IDgtOCA4IDMuNiA4IDgtMy42IDgtOCA4ek03IDR2MmgyVjRIN3ptMiAzdjRoMXYxSDZ2LTFoMVY4SDZWN2gzeiIvPjwvc3ZnPg==';
const info_s_md = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgZml0PSIiIGhlaWdodD0iMTAwJSIgd2lkdGg9IjEwMCUiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIGZvY3VzYWJsZT0iZmFsc2UiIGZpbGw9IiMwMDZhYzMiPjxwYXRoIGQ9Ik0xNiAwQzcuMiAwIDAgNy4yIDAgMTZzNy4yIDE2IDE2IDE2IDE2LTcuMiAxNi0xNlMyNC44IDAgMTYgMHptMCA5LjVjLjcgMCAxLjIuNiAxLjIgMS4yUzE2LjcgMTIgMTYgMTJzLTEuMi0uNi0xLjItMS4yLjUtMS4zIDEuMi0xLjN6bTIgMTNoLTRjLS40IDAtLjctLjMtLjctLjcgMC0uNC4zLS43LjctLjdoMS4zdi01LjlIMTRjLS40IDAtLjctLjMtLjctLjcgMC0uNC4zLS43LjctLjdoMmMuNCAwIC43LjMuNy43djYuNkgxOGMuNCAwIC43LjMuNy43IDAgLjMtLjMuNy0uNy43eiIvPjwvc3ZnPg==';
const times = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiIgZml0PSIiIGhlaWdodD0iMTAwJSIgd2lkdGg9IjEwMCUiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIGZvY3VzYWJsZT0iZmFsc2UiIGZpbGw9IiMwMDZhYzMiPjxwYXRoIGNsYXNzPSJlZ2MxIiBkPSJNOC43MDcgOEwxNS44NTQuODU0YS41LjUgMCAxIDAtLjcwOC0uNzA4TDggNy4yOTMuODU0LjE0NmEuNS41IDAgMSAwLS43MDguNzA4TDcuMjkzIDggLjE0NiAxNS4xNDZhLjUuNSAwIDEgMCAuNzA4LjcwOEw4IDguNzA3bDcuMTQ2IDcuMTQ3YS40OTguNDk4IDAgMCAwIC43MDggMCAuNS41IDAgMCAwIDAtLjcwOEw4LjcwNyA4eiIvPjwvc3ZnPg==';
const times_md = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgZml0PSIiIGhlaWdodD0iMTAwJSIgd2lkdGg9IjEwMCUiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIGZvY3VzYWJsZT0iZmFsc2UiIGZpbGw9IiMwMDZhYzMiPjxwYXRoIGNsYXNzPSJlaGMxIiBkPSJNMzEuNzk1LjIwNWEuNy43IDAgMCAwLS45OSAwTDE2IDE1LjAxIDEuMTk1LjIwNWEuNy43IDAgMCAwLS45OS45OUwxNS4wMSAxNiAuMjA1IDMwLjgwNWEuNy43IDAgMCAwIC45OS45OUwxNiAxNi45OWwxNC44MDUgMTQuODA1YS42OTguNjk4IDAgMCAwIC45OSAwIC43LjcgMCAwIDAgMC0uOTlMMTYuOTkgMTYgMzEuNzk1IDEuMTk1YS43LjcgMCAwIDAgMC0uOTl6Ii8+PC9zdmc+';

var icons = /*#__PURE__*/Object.freeze({
  __proto__: null,
  help: help,
  help_md: help_md,
  help_s: help_s,
  help_s_md: help_s_md,
  info: info,
  info_md: info_md,
  info_s: info_s,
  info_s_md: info_s_md,
  times: times,
  times_md: times_md
});

let nextUniqueID = 0;
const screenBreakpoint = 576;
const isSmallBreakpoint = () => window.innerWidth < screenBreakpoint;
const Tooltip = props => {
  const isFr = document.documentElement.lang.includes('fr');
  const {
    id = useRef(`rbc-tooltip-${++nextUniqueID}`).current,
    placement = 'top',
    small = false,
    help = true,
    blur = false,
    width,
    label,
    tooltipAriaLabel,
    closeIconAriaLabel = isFr ? 'Fermer' : 'Close',
    ariaDescribedBy,
    children,
    boundary,
    className,
    customTrigger
  } = props;
  const [isContentOpen, setIsContentOpen] = useState(false);
  const startMessage = isFr ? "Début de l'info-bulle" : 'Start of tooltip';
  const endMessage = isFr ? "Fin de l'info-bulle" : 'End of tooltip';
  // tslint:disable-next-line:no-non-null-assertion
  const tooltipButton = useRef(null);
  // tslint:disable-next-line:no-non-null-assertion
  const tooltipContainer = useRef(null);
  // tslint:disable-next-line:no-non-null-assertion
  const arrow = useRef(null);
  const onClick = () => {
    setIsContentOpen(!isContentOpen);
  };
  const onBlur = () => {
    if (blur) {
      let containerClicked = false;
      if (tooltipContainer && tooltipContainer.current) tooltipContainer.current.addEventListener('click', e => {
        if (!tooltipContainer.current.contains(e.relatedTarget)) {
          containerClicked = true;
        }
      });
      setTimeout(() => {
        const activeElement = document.activeElement;
        if (tooltipContainer && tooltipContainer.current) if (!containerClicked && !tooltipContainer.current.contains(activeElement)) setIsContentOpen(false);
      }, 150); //Blur to click offset delay
    }
  };

  useLayoutEffect(() => {
    if (isContentOpen) {
      smartPosition();
      adjustWidth();
      tooltipContainer.current.style.visibility = 'visible';
      // tooltipContainer.current.focus(); //Open button should stay focused, SR will read live content on open
      if (blur) {
        tooltipContainer.current.addEventListener('focusout', e => {
          if (!tooltipContainer.current.contains(e.relatedTarget)) {
            setIsContentOpen(false);
          }
        });
      }
      return () => tooltipButton.current.focus();
    }
    return () => {};
  }, [isContentOpen]);
  const smartPosition = () => {
    var _window$navigator;
    const isSafari = ((_window$navigator = window.navigator) == null ? void 0 : _window$navigator.vendor) === 'Apple Computer, Inc.';
    if (isSmallBreakpoint() || !placement.includes('bottom')) {
      let chevronTop = '';
      if (tooltipContainer.current.getBoundingClientRect().top < 0) {
        if (isSafari) {
          chevronTop = small ? '22px' : '32px';
        } else {
          chevronTop = small ? '24px' : '34px';
        }
        const containerTop = small ? '32px' : '42px';
        arrow.current.style.transform = 'rotate(225deg)';
        arrow.current.style.bottom = 'auto';
        tooltipContainer.current.style.top = containerTop;
        tooltipContainer.current.style.bottom = 'auto';
      } else if (isSafari) {
        chevronTop = typeof props.children === 'object' ? '-24px' : '-22px';
      }
      arrow.current.style.top = chevronTop;
    }
  };
  const adjustWidth = () => {
    if (isSmallBreakpoint()) {
      const relativeLoc = tooltipButton.current.getBoundingClientRect();
      tooltipContainer.current.style.width = `${window.innerWidth - 32}px`;
      tooltipContainer.current.style.left = `${-Math.abs(relativeLoc.left) + 16}px`;
    } else {
      let leftBoundary = 0;
      let rightBoundary = window.innerWidth;
      if (boundary) {
        // tslint:disable-next-line:no-non-null-assertion
        leftBoundary = document.getElementById(boundary).getBoundingClientRect().left;
        // tslint:disable-next-line:no-non-null-assertion
        rightBoundary = document.getElementById(boundary).getBoundingClientRect().right;
      }
      const containerRect = tooltipContainer.current.getBoundingClientRect();
      let offset;
      if (containerRect.left < leftBoundary) {
        offset = `${leftBoundary - containerRect.left + 16}px`;
      } else if (containerRect.right > rightBoundary) {
        offset = `${rightBoundary - containerRect.right - 16}px`;
      }
      if (offset) {
        tooltipContainer.current.style.marginLeft = offset;
      }
    }
  };
  const resolveIcon = name => icons[small ? name : `${name}_md`];
  const arrowSpan = () => jsx("span", {
    ref: arrow,
    className: "arrow",
    small: small ? 'true' : undefined,
    placement: placement
  });
  return jsx("div", {
    className: classNames('rbc-tooltip__wrapper', {
      'rbc-tooltip--inline': !label
    }, className),
    children: jsxs("div", {
      id: `${id}-label-container`,
      className: "label-container",
      children: [label, jsxs("div", {
        className: "tooltip-button-container",
        children: [customTrigger ? jsxs("div", {
          ref: tooltipButton,
          role: "button",
          tabIndex: 0,
          id: id,
          onClick: onClick,
          onKeyPress: e => {
            if (e.key === 'Enter') e.currentTarget.click();
          },
          onBlur: onBlur,
          "aria-labelledby": label && !tooltipAriaLabel && `${id}-label-container`,
          "aria-label": tooltipAriaLabel,
          "aria-describedby": ariaDescribedBy,
          placement: placement,
          "aria-expanded": isContentOpen,
          children: [isContentOpen && arrowSpan(), customTrigger]
        }) : jsxs("button", {
          ref: tooltipButton,
          type: "button",
          id: id,
          className: "tooltip-button",
          onClick: onClick,
          onBlur: onBlur,
          "aria-labelledby": label && !tooltipAriaLabel && `${id}-label-container`,
          "aria-label": tooltipAriaLabel,
          "aria-describedby": ariaDescribedBy,
          placement: placement,
          "aria-expanded": isContentOpen,
          children: [isContentOpen && arrowSpan(), jsx("div", {
            className: classNames('tooltip-open__icon rbc-icon', {
              'small sm': small,
              md: !small
            }),
            "aria-hidden": "true",
            children: jsx("img", {
              src: help ? resolveIcon('help') : resolveIcon('info')
            })
          }), jsx("div", {
            className: classNames('tooltip-open__icon rbc-icon hover', {
              'small sm': small,
              md: !small
            }),
            "aria-hidden": "true",
            children: jsx("img", {
              src: help ? resolveIcon('help_s') : resolveIcon('info_s')
            })
          })]
        }), isContentOpen && jsxs("div", {
          ref: tooltipContainer,
          id: `${id}-content-container`,
          className: "rbc-tooltip__container",
          style: width ? {
            width: width
          } : undefined,
          small: small ? 'true' : undefined,
          placement: placement,
          role: "tooltip",
          tabIndex: -1,
          children: [jsx("span", {
            className: "rbc-sr-only",
            children: startMessage
          }), jsx("div", {
            className: "rbc-tooltip-content-container",
            children: jsx("div", {
              className: "rbc-tooltip-content",
              children: children
            })
          }), jsx("button", {
            id: `${id}-x-button`,
            className: "tooltip-close-button",
            onClick: () => setIsContentOpen(!isContentOpen),
            "aria-label": closeIconAriaLabel,
            children: jsx("img", {
              className: "rbc-icon sm",
              src: times
            })
          }), jsx("span", {
            className: "rbc-sr-only",
            children: endMessage
          })]
        })]
      })]
    })
  });
};

const _excluded$4 = ["kind", "size", "emphasis", "overrides", "elementType", "children", "className"];
const TextStyle = _ref => {
  let {
      kind,
      size,
      emphasis,
      overrides,
      elementType,
      children,
      className = ''
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  const Element = elementType || 'span';
  isTextInputDataValid({
    kind,
    size,
    emphasis,
    overrides
  });
  const textClassNames = createTextClassNames({
    kind,
    size,
    emphasis,
    overrides
  });
  return jsx(Element, Object.assign({
    className: `${textClassNames} ${className}`
  }, props, {
    children: children
  }));
};

const _excluded$3 = ["useCase", "children"];
const TextBigNumber = _ref => {
  let {
      useCase = BigNumberUseCase.default,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  const textSize = Object.values(BigNumberUseCase).includes(useCase) ? BigNumberTextSizeMap[useCase] : TextSize.default;
  return jsx(TextStyle, Object.assign({
    kind: "bignumber",
    size: textSize,
    elementType: "span"
  }, props, {
    children: children
  }));
};

const _excluded$2 = ["useCase", "headingLevel", "children"];
const TextHeading = _ref => {
  let {
      useCase,
      headingLevel,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  const sizeMapData = Object.values(HeadingUseCase).includes(useCase) ? HeadingTextSizeMap[useCase] : undefined;
  let textSize, textOverride;
  if (sizeMapData) {
    textSize = sizeMapData.size;
    textOverride = sizeMapData.override;
  }
  return jsx(TextStyle, Object.assign({
    kind: TextKind.heading,
    size: textSize,
    overrides: textOverride,
    elementType: headingLevel
  }, props, {
    children: children
  }));
};

const _excluded$1 = ["useCase", "children"];
const TextParagraph = _ref => {
  let {
      useCase,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  const textSize = useCase && Object.values(ParagraphUseCase).includes(useCase) ? ParagraphTextSizeMap[useCase] : TextSize.default;
  return jsx(TextStyle, Object.assign({
    kind: TextKind.paragraph,
    size: textSize,
    elementType: "p"
  }, props, {
    children: children
  }));
};

const _excluded = ["useCase", "children"];
const TextUI = _ref => {
  let {
      useCase = TextUIUseCase.default,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const textSize = Object.values(TextUIUseCase).includes(useCase) ? TextUISizeMap[useCase].size : TextSize.default;
  const textEmphasis = Object.values(TextUIUseCase).includes(useCase) ? TextUISizeMap[useCase].emphasis : TextEmphasis.default;
  return jsx(TextStyle, Object.assign({
    kind: "ui",
    size: textSize,
    emphasis: textEmphasis,
    elementType: "p"
  }, props, {
    children: children
  }));
};

export { BoxContainer, CTA, CTAText, ColumnItem, ColumnItemComponent, ColumnLayout, ColumnLayoutComponent, Copy, Divider, FlexItem, FlexItemComponent, FlexLayout, FlexLayoutComponent, I18nContext, I18nProvider, IconRegistry, IconRegistryContext, IconRegistryProvider, Input, KeyValueList, KeyValueListContext, Label, LayoutContainer, LinkComponentContext, LinkComponentProvider, MenuGrid, MenuGroup, MenuItem, MenuItemContent, MenuItemExpandable, NavProduct, Page, PageComponent, RBCActionPanel, RBCGlobalProvider, RBCIcon, RBCIconButton, RBCNav, RBCNavTab, RBCNavTabs, RBCNotificationBadge, RBCPanel, RBCProfileBox, RBCScrollContainer, RBCSuiteNavigation, Select, Stack, SvgUtils, Tab, TabPanel, Tabs, TextBigNumber, TextHeading, TextParagraph, TextStyle, TextUI, Tooltip, checkBpCustomizableAndReturn, checkEmptyObject, clearPlacements, constructClassNames, createIconRegistry, debounce, defaultConfiguration, defaultLocale, dispatchEvent$1 as dispatchEvent, generateBreakpointUtilityClasses, getBreakpointValue, iconRegistry, isBreakPointCustomizable, setPlacement, sortDOMOrder, useBreakPointService, useLinkComponent, useLocale, useLockScroll, useWindowSize };
